// export const servicesData = [


//     {
//         "id": "1",
//          "pdf_Url":"https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_HealthCloud.pdf",
//         "name": "Salesforce Health Cloud",
//         "shortDescription": "Salesforce Health Cloud for patient, providers and medications management",
//         "headline": "Enable easy accessibility to care for your patients and PHI to the providers.",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/health-cloud1.png",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Set up highly personalized patient care management with unified profiles, care plans, clinical insights, and engagement timelines that allow providers to deliver tailored treatment experiences."
//             },
//             {
//                 "id": "2",
//                 "name": "Securely store and manage PHI across HIPAA and HL7-compliant clinical data models ensuring regulatory compliance, privacy protection, and standardized interoperability."
//             },
//             {
//                 "id": "3",
//                 "name": "Build a comprehensive health timeline combining visits, medications, lab results, and provider notes to give care teams a complete 360-degree medical history."
//             },
//             {
//                 "id": "4",
//                 "name": "Synchronize CRM and EHR systems bi-directionally to maintain real-time data accuracy, eliminate duplicate records, and improve clinical decision making."
//             },
//             {
//                 "id": "5",
//                 "name": "Develop fully connected healthcare ecosystems integrating devices, apps, portals, and providers for seamless patient engagement and coordinated care delivery."
//             }
//         ],
//         "storyId": 1,
//         'storyheadline': 'connected-crm-ehr-and-website-to-help-patients-and-providers',
//         "impact": {
//             "description": "Antrazal's extensive technical and industry tailored solutioning human-centric approach can help achieve your digitalization goals for the future.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "10+",
//                     "title": "Health and Phrama digitalization"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "50+",
//                     "name": "Customer/Providers Portal developed"
//                 }
//             ]
//         }
//     },


//     {
//         "id": "12",
//         "category": "Salesforce",
//         "name": "Salesforce Data Cloud",
//         "slug": "salesforce-data-cloud",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Pill%402x.webp",
//         "shortDescription": "Salesforce Data Cloud for real-time unified customer data, identity resolution, and AI-powered insights.",
//         "headline": "Transform fragmented data into a single intelligent customer profile for smarter decisions.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Resolve identities across multiple systems and channels using advanced matching algorithms to create accurate, persistent, and unified customer records."
//             },
//             {
//                 "id": "2",
//                 "name": "Ingest streaming and batch data from diverse sources such as CRM, web, mobile, IoT, and third-party platforms for real-time data activation."
//             },
//             {
//                 "id": "3",
//                 "name": "Build comprehensive unified profiles that consolidate behavioral, transactional, and demographic data for a complete 360-degree customer view."
//             },
//             {
//                 "id": "4",
//                 "name": "Prepare AI-ready datasets that enable predictive analytics, personalization engines, and automation workflows powered by trusted data."
//             },
//             {
//                 "id": "5",
//                 "name": "Implement robust governance, consent, and compliance tools to ensure data quality, privacy, and secure enterprise-grade data management."
//             }
//         ],
//         "storyId": 12,
//         "storyheadline": "unified-real-time-customer-data-platform-for-personalization-and-analytics",
//         "impact": {
//             "description": "Antrazal's extensive technical and industry tailored solutioning human-centric approach can help achieve your digitalization goals for the future.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "15+",
//                     "title": "Enterprise data platforms implemented"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "100+",
//                     "name": "Data integrations and pipelines delivered"
//                 }
//             ]
//         }
//     },


//     {
//         "id": "2",
//          "pdf_Url":"https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_RevenueCloud.pdf",
//         "name": "Salesforce Revenue Cloud (CPQ)",
//         "shortDescription": "Salesforce Revenue Cloud (CPQ) for intelligent quoting, pricing, billing, inventory, and subscription lifecycle management.",
//         "headline": "Configure fast, guided, and error-proof personalized product bundles, pricing, and discounts with automation.",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/SF-Revenue-Cloud-CPQ-1.png",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Centralize and digitize every product, bundle, price book, and discount schedule within a unified system that ensures consistency, scalability, and easy management across sales channels."
//             },
//             {
//                 "id": "2",
//                 "name": "Embed intelligent selling logic and automated validation rules that prevent configuration errors, enforce pricing policies, and automatically protect deal margins."
//             },
//             {
//                 "id": "3",
//                 "name": "Accelerate the generation of branded, accurate quotes and legally binding contracts using automated templates, approvals, and one-click document creation."
//             },
//             {
//                 "id": "4",
//                 "name": "Seamlessly convert accepted quotes into revenue-tracked orders, assets, invoices, and subscription records for complete lifecycle visibility and operational efficiency."
//             },
//             {
//                 "id": "5",
//                 "name": "Continuously monitor performance metrics, analyze deal trends, and refine pricing strategies using data insights to maximize profitability and long-term ROI."
//             }
//         ],
//         "storyId": 2,
//         "storyheadline": "smarter-revenue-verified-at-every-stage",
//         "impact": {
//             "description": "Antrazal empowers organizations to maximize revenue efficiency with Salesforce Revenue Cloud (CPQ) through intelligent configuration, automated pricing, and streamlined quote-to-cash processes that accelerate deal velocity and ensure margin accuracy.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "5000+",
//                     "title": "Products and Bundles configured"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "50+",
//                     "name": "External integrations"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "14",
//         "category": "Salesforce",
//         "name": "Salesforce Agentforce",
//         "slug": "salesforce-agentforce",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/eyJidWNrZXQiOiJwYXJ0bmVycGFnZS5wcm9kIiwia2V5IjoibWVkaWEvY29udGFjdF9pbWFnZXMvNWI4ZTAwYjMtNDY5YS00NTQ4LWI1MDgtNDZiZWQyOGRiY2ExL2RlYTVjMGM1LWVmN2QtNDJiNS04YTQwLTQ1ZjM2OGJlNDkxOC5wbmc.webp",
//         "shortDescription": "Salesforce Agentforce for AI-powered autonomous agents, workflow automation, and intelligent operational productivity.",
//         "headline": "Increase productivity with intelligent automation driven by autonomous AI agents.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Deploy autonomous AI agents capable of executing tasks, making decisions, and completing business processes with minimal human intervention."
//             },
//             {
//                 "id": "2",
//                 "name": "Leverage predictive intelligence to anticipate tasks, recommend next actions, and proactively optimize workflows across teams and systems."
//             },
//             {
//                 "id": "3",
//                 "name": "Orchestrate complex workflows across departments, applications, and data sources to streamline operations and eliminate manual bottlenecks."
//             },
//             {
//                 "id": "4",
//                 "name": "Empower employees with AI copilots that assist in real time, providing contextual insights, suggestions, and automation support for faster execution."
//             },
//             {
//                 "id": "5",
//                 "name": "Gain deep operational insights through analytics and monitoring tools that track performance, efficiency, and automation impact across processes."
//             }
//         ],
//         "storyId": 14,
//         "storyheadline": "ai-powered-automation-for-smarter-business-operations",
//         "impact": {
//             "description": "Antrazal enables organizations to scale productivity and operational intelligence with Salesforce Agentforce by deploying autonomous AI agents, orchestrating workflows, and delivering real-time decision support that drives measurable efficiency and faster business outcomes.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "200+",
//                     "title": "Automated workflows deployed"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "70+",
//                     "name": "AI-driven process implementations"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "3",
//         "pdf_Url":'https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_MarketingCloud.pdf',
//         "name": "Salesforce Marketing Cloud",
//         "shortDescription": "Salesforce Marketing Cloud for personalized omnichannel campaigns, audience engagement, and data-driven marketing performance.",
//         "headline": "Deliver timely, personalized cross-channel communications that maximize engagement and conversions.",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/salesforce_marketing-cloud-logo.webp",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Create advanced audience segmentation using behavioral, demographic, and interaction data to precisely target customers with relevant messaging."
//             },
//             {
//                 "id": "2",
//                 "name": "Execute consent-driven, insight-led omnichannel marketing campaigns that respect preferences while improving engagement effectiveness."
//             },
//             {
//                 "id": "3",
//                 "name": "Design and automate multi-touchpoint customer journeys across lifecycle stages to nurture leads and strengthen long-term relationships."
//             },
//             {
//                 "id": "4",
//                 "name": "Send emails, SMS, and push notifications at AI-optimized times to increase open rates, response rates, and campaign performance."
//             },
//             {
//                 "id": "5",
//                 "name": "Integrate marketing data, analytics, and reporting dashboards to continuously refine strategies and drive measurable ROI improvements."
//             }
//         ],
//         "storyId": 3,
//         "storyheadline": "timely-notifications-to-the-patients-and-gps",
//         "impact": {
//             "description": "Antrazal empowers organizations with intelligent marketing ecosystems that enhance customer engagement, optimize campaign performance, and accelerate growth through data-driven decision making.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "250+",
//                     "title": "Customer journeys built"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "20M+",
//                     "name": "Target audience managed"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "16",
//         "category": "Salesforce",
//         "name": "Salesforce Field Service",
//         "pdf_Url": "https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_MobileApp_And_FieldServiceLightning.pdf",
//         "slug": "salesforce-field-service",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/salesforce_field_service_cloud.webp",
//         "shortDescription": "Salesforce Field Service for intelligent scheduling, technician productivity, and real-time service operations management.",
//         "headline": "Deliver faster, smarter on-site service experiences with optimized scheduling and dispatch automation.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Implement intelligent scheduling tools that automatically assign the right technician based on skills, availability, priority, and service location."
//             },
//             {
//                 "id": "2",
//                 "name": "Optimize service routes using real-time traffic, distance, and job urgency data to reduce travel time and increase daily job completion rates."
//             },
//             {
//                 "id": "3",
//                 "name": "Equip technicians with a powerful mobile app that provides work orders, customer history, checklists, and offline capabilities for seamless field execution."
//             },
//             {
//                 "id": "4",
//                 "name": "Track jobs in real time with live status updates, automated notifications, and visibility dashboards for improved coordination and customer satisfaction."
//             },
//             {
//                 "id": "5",
//                 "name": "Enable predictive maintenance by analyzing asset data and service history to anticipate issues before failures occur and reduce downtime."
//             }
//         ],
//         "storyId": 16,
//         "storyheadline": "optimized-field-operations-with-real-time-service-visibility",
//         "impact": {
//             "description": "Antrazal delivers intelligent field service solutions that enhance technician efficiency, improve customer satisfaction, and streamline service operations through automation and real-time insights.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "120+",
//                     "title": "Field service processes automated"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "85+",
//                     "name": "Technician mobility solutions deployed"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "4",
//          "pdf_Url":"https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_ExperienceCloud.pdf",
//         "name": "Salesforce Experience Cloud",
//         "shortDescription": "Salesforce Experience Cloud for scalable digital portals, partner ecosystems, and interactive global engagement platforms.",
//         "headline": "Power technology-driven global engagement with dynamic, data-rich digital experiences.",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/salesforce-experience-cloud-logo.webp",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Launch high-performance Lightning Web Runtime (LWR) sites engineered for global scale, fast load times, and enterprise-grade reliability."
//             },
//             {
//                 "id": "2",
//                 "name": "Design interactive and visually rich geographic experiences using D3.js-powered world maps for intuitive exploration of global data."
//             },
//             {
//                 "id": "3",
//                 "name": "Deliver real-time KPI visualization through dynamic ChartJS dashboards that transform complex datasets into actionable insights."
//             },
//             {
//                 "id": "4",
//                 "name": "Surface secure API-connected data with advanced filtering, drill-down views, and role-based access for personalized user experiences."
//             },
//             {
//                 "id": "5",
//                 "name": "Build modular Lightning Web Components that enable scalable architecture, rapid enhancements, and consistent user interface design."
//             },
//             {
//                 "id": "6",
//                 "name": "Optimize mobile-first performance to ensure seamless accessibility, responsiveness, and usability across devices and global regions."
//             },
//             {
//                 "id": "7",
//                 "name": "Enable centralized visibility into global program performance with unified dashboards that support strategic decision making."
//             }
//         ],
//         "storyId": 4,
//         "storyheadline": "elevating-global-impact-visibility-with-a-dynamic-lightning-web-runtime-platform",
//         "impact": {
//             "description": "Antrazal builds scalable digital experience platforms that empower organizations to visualize global impact, enhance stakeholder engagement, and drive data-informed decisions with confidence.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "100+",
//                     "title": "Countries visualized"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "10+",
//                     "name": "Scalable platform architecture delivered"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "18",
//         "category": "Salesforce",
//         "name": "Salesforce Service Cloud",
//         "slug": "salesforce-service-cloud",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Salesforce-Service-Cloud-Logo.webp",
//         "shortDescription": "Salesforce Service Cloud for AI-powered customer support, intelligent case management, and seamless service experiences.",
//         "headline": "Resolve customer cases faster with smart automation, AI insights, and unified support channels.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Deliver omnichannel support across phone, email, chat, social media, and messaging platforms from a single unified service console."
//             },
//             {
//                 "id": "2",
//                 "name": "Automatically route cases using AI-driven logic that matches customer needs with the most qualified agents for faster resolution."
//             },
//             {
//                 "id": "3",
//                 "name": "Launch scalable self-service portals that empower customers to find answers, submit requests, and track cases independently."
//             },
//             {
//                 "id": "4",
//                 "name": "Build intelligent knowledge bases that provide agents and customers with accurate, searchable information for consistent support delivery."
//             },
//             {
//                 "id": "5",
//                 "name": "Analyze service performance using real-time dashboards and reports to improve efficiency, satisfaction scores, and operational outcomes."
//             }
//         ],
//         "storyId": 18,
//         "storyheadline": "ai-driven-customer-service-transformation-for-faster-resolution",
//         "impact": {
//             "description": "Antrazal implements intelligent customer service solutions that enhance support efficiency, elevate customer satisfaction, and streamline service operations through automation and actionable insights.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "300+",
//                     "title": "Support workflows automated"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "90+",
//                     "name": "Service process optimizations delivered"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "19",
//         "category": "Salesforce",
//         "name": "Salesforce Implementation",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Salesforce.com_logo.svg.png",
//         "slug": "salesforce-implementation",
//         "shortDescription": "Salesforce implementation services for scalable CRM architecture, automation, integrations, and optimized business processes.",
//         "headline": "Launch faster with a scalable, secure, and future-ready Salesforce architecture.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Design robust and scalable system architectures tailored to business requirements, ensuring performance, security, and long-term platform stability."
//             },
//             {
//                 "id": "2",
//                 "name": "Configure custom objects, fields, relationships, and data models to accurately represent business processes and operational workflows."
//             },
//             {
//                 "id": "3",
//                 "name": "Build automation flows, approval processes, and business logic that streamline operations, reduce manual effort, and improve productivity."
//             },
//             {
//                 "id": "4",
//                 "name": "Integrate Salesforce with external systems, APIs, and third-party platforms to enable seamless data synchronization and unified operations."
//             },
//             {
//                 "id": "5",
//                 "name": "Provide end-to-end training, testing, deployment, and post-launch support to ensure successful adoption and long-term platform success."
//             }
//         ],
//         "storyId": 19,
//         "storyheadline": "scalable-salesforce-platform-launch-for-digital-transformation",
//         "impact": {
//             "description": "Antrazal delivers tailored Salesforce implementation solutions that align technology with business goals, accelerate digital transformation, and ensure long-term platform success.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "150+",
//                     "title": "Salesforce environments deployed"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "120+",
//                     "name": "Enterprise integrations delivered"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "21",
//         "category": "Healthcare Solutions",
//         "name": "EDI Processor",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/EDIX12image.jpg",
//         "slug": "edi-processor",
//         "shortDescription": "EDI Processor for automated healthcare claims processing, transaction validation, and compliant data exchange workflows.",
//         "headline": "Streamline healthcare transactions and reduce manual errors with intelligent EDI automation.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Parse complex EDI transaction files accurately, converting structured healthcare data into standardized, system-ready formats for processing."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate claims processing workflows to accelerate approvals, reduce manual intervention, and improve operational efficiency across billing cycles."
//             },
//             {
//                 "id": "3",
//                 "name": "Apply advanced validation rules to detect inconsistencies, missing data, and formatting issues before submission to ensure data accuracy."
//             },
//             {
//                 "id": "4",
//                 "name": "Support industry-compliant healthcare transaction formats including HIPAA-standard EDI structures for secure and reliable data exchange."
//             },
//             {
//                 "id": "5",
//                 "name": "Implement intelligent error handling and reporting mechanisms that identify, log, and resolve transaction failures quickly and efficiently."
//             }
//         ],
//         "storyId": 21,
//         "storyheadline": "automated-healthcare-edi-processing-for-faster-claims-and-compliance",
//         "impact": {
//             "description": "Antrazal delivers advanced healthcare automation solutions that enhance claims accuracy, ensure compliance, and accelerate transaction processing through intelligent EDI technologies.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "5M+",
//                     "title": "Healthcare transactions processed"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "99.9%",
//                     "name": "Data processing accuracy achieved"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "22",
//         "category": "Healthcare Solutions",
//         "name": "FHIR & HL7 Integration",
//         "slug": "fhir-hl7-integration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/HL7_FHIR_logo.webp",
//         "shortDescription": "FHIR and HL7 integration services for secure healthcare interoperability, clinical data exchange, and connected health systems.",
//         "headline": "Connect clinical systems securely with standardized, real-time healthcare data interoperability.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Develop and implement FHIR-based APIs that enable standardized, scalable, and secure access to healthcare data across applications and platforms."
//             },
//             {
//                 "id": "2",
//                 "name": "Configure HL7 interfaces to facilitate seamless communication between EHRs, laboratory systems, billing platforms, and clinical applications."
//             },
//             {
//                 "id": "3",
//                 "name": "Synchronize clinical data across multiple healthcare systems to ensure accurate, consistent, and up-to-date patient information."
//             },
//             {
//                 "id": "4",
//                 "name": "Enable real-time data exchange between providers, partners, and healthcare platforms for faster decision-making and coordinated care delivery."
//             },
//             {
//                 "id": "5",
//                 "name": "Ensure full healthcare compliance with industry standards and regulatory requirements while maintaining data security and patient privacy."
//             }
//         ],
//         "storyId": 22,
//         "storyheadline": "secure-healthcare-interoperability-with-real-time-clinical-data-integration",
//         "impact": {
//             "description": "Antrazal provides advanced interoperability solutions that unify healthcare systems, enhance data accessibility, and support efficient, secure clinical collaboration across digital ecosystems.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "80+",
//                     "title": "Healthcare systems integrated"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "10M+",
//                     "name": "Clinical records synchronized"
//                 }
//             ]
//         }
//     },


//     {
//         "id": "31",
//         "category": "Integration",
//         "name": "MuleSoft",
//         "slug": "mulesoft-integration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/MuleSoft_logo-1526192436.webp",
//         "shortDescription": "MuleSoft integration services for enterprise APIs, system connectivity, and scalable data orchestration across platforms.",
//         "headline": "Connect systems, data, and applications through secure and scalable integration architecture.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Design robust, reusable APIs using best practices and governance standards to enable scalable and consistent digital integration strategies."
//             },
//             {
//                 "id": "2",
//                 "name": "Integrate enterprise systems, legacy platforms, cloud applications, and databases to create seamless, unified business workflows."
//             },
//             {
//                 "id": "3",
//                 "name": "Orchestrate data flows across multiple services and platforms to ensure real-time synchronization, accuracy, and operational efficiency."
//             },
//             {
//                 "id": "4",
//                 "name": "Implement middleware architectures that simplify complex integrations, reduce system dependencies, and improve overall performance."
//             },
//             {
//                 "id": "5",
//                 "name": "Secure endpoints and APIs using authentication, encryption, and policy enforcement mechanisms to protect enterprise data and services."
//             }
//         ],
//         "storyId": 31,
//         "storyheadline": "scalable-enterprise-integration-with-api-led-connectivity",
//         "impact": {
//             "description": "Antrazal delivers enterprise-grade integration solutions that unify systems, accelerate data exchange, and enable organizations to innovate faster through connected digital ecosystems.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "250+",
//                     "title": "APIs designed and deployed"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "120+",
//                     "name": "Systems successfully integrated"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "32",
//         "category": "Integration",
//         "name": "Celigo",
//         "slug": "celigo-integration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/celigo-logo-png_seeklogo-445990.webp",
//         "shortDescription": "Celigo integration services for automating workflows, connecting SaaS applications, and streamlining cross-platform data synchronization.",
//         "headline": "Automate business processes seamlessly by connecting your SaaS systems in real time.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Utilize prebuilt connectors to rapidly integrate popular SaaS applications, reducing implementation time and simplifying system connectivity."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate complex workflows across business platforms to eliminate manual tasks, improve efficiency, and ensure consistent operational execution."
//             },
//             {
//                 "id": "3",
//                 "name": "Monitor integration processes with intelligent error detection and alerts that quickly identify issues and prevent workflow disruptions."
//             },
//             {
//                 "id": "4",
//                 "name": "Configure advanced data mapping rules to transform, standardize, and synchronize information between multiple systems accurately."
//             },
//             {
//                 "id": "5",
//                 "name": "Enable real-time data synchronization across connected applications to maintain up-to-date records and support informed decision making."
//             }
//         ],
//         "storyId": 32,
//         "storyheadline": "seamless-saas-integration-for-automated-business-operations",
//         "impact": {
//             "description": "Antrazal provides intelligent integration solutions that streamline application connectivity, automate business workflows, and enhance operational visibility across digital ecosystems.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "180+",
//                     "title": "Integrations deployed"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "95+",
//                     "name": "Automated workflows implemented"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "33",
//         "category": "Integration",
//         "name": "QuickBooks",
//         "slug": "quickbooks-integration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/quickbooklogo.webp",
//         "shortDescription": "QuickBooks integration services for automated accounting synchronization, financial visibility, and seamless CRM connectivity.",
//         "headline": "Synchronize financial data automatically to streamline accounting and business operations.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Synchronize invoices between accounting and business systems to ensure accurate billing records and eliminate duplicate manual entry."
//             },
//             {
//                 "id": "2",
//                 "name": "Track payments in real time with automated updates that reflect transaction statuses across connected platforms."
//             },
//             {
//                 "id": "3",
//                 "name": "Sync customer data across CRM, ERP, and accounting tools to maintain consistent records and improve financial accuracy."
//             },
//             {
//                 "id": "4",
//                 "name": "Generate comprehensive financial reports by consolidating accounting data into unified dashboards for informed decision making."
//             },
//             {
//                 "id": "5",
//                 "name": "Create automation rules that trigger workflows such as invoice generation, payment reminders, and reconciliation processes."
//             }
//         ],
//         "storyId": 33,
//         "storyheadline": "automated-financial-data-sync-for-accurate-accounting-operations",
//         "impact": {
//             "description": "Antrazal delivers reliable financial integration solutions that enhance accounting accuracy, improve operational efficiency, and provide real-time financial visibility across business systems.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "300+",
//                     "title": "Accounting integrations completed"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "99.8%",
//                     "name": "Financial data accuracy achieved"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "34",
//         "category": "Integration",
//         "name": "NetSuite",
//         "slug": "netsuite-integration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/NetSuite-logo-mobius.webp",
//         "shortDescription": "NetSuite integration services for unified ERP connectivity, automated operations, and synchronized financial and business data.",
//         "headline": "Connect your ERP seamlessly with the entire business ecosystem for real-time operational visibility.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Synchronize ERP data across CRM, eCommerce, logistics, and finance systems to maintain accurate and consistent enterprise records."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate order processing workflows that seamlessly transfer sales data between platforms for faster fulfillment and reduced manual work."
//             },
//             {
//                 "id": "3",
//                 "name": "Enable real-time inventory synchronization across warehouses, storefronts, and supply chain systems to prevent stock discrepancies."
//             },
//             {
//                 "id": "4",
//                 "name": "Streamline finance workflows by integrating billing, accounting, and payment systems for efficient financial operations and reporting."
//             },
//             {
//                 "id": "5",
//                 "name": "Deliver analytics-ready data feeds that consolidate operational insights and support strategic decision making across departments."
//             }
//         ],
//         "storyId": 34,
//         "storyheadline": "connected-erp-ecosystem-for-streamlined-business-operations",
//         "impact": {
//             "description": "Antrazal provides enterprise ERP integration solutions that unify business processes, enhance operational transparency, and empower organizations with real-time data-driven insights.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "140+",
//                     "title": "ERP integrations delivered"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "60+",
//                     "name": "Business systems connected"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "35",
//         "category": "Integration",
//         "name": "DocuSign",
//         "slug": "docusign-integration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/DocuSign-Logo.webp",
//         "shortDescription": "DocuSign integration services for automated digital signatures, contract workflows, and secure document management.",
//         "headline": "Automate document approvals and contract processes with secure, compliant digital signing.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Automate signature collection processes that send documents for signing, track completion status, and store finalized records without manual effort."
//             },
//             {
//                 "id": "2",
//                 "name": "Streamline contract workflows by integrating approval steps, notifications, and document routing across business systems."
//             },
//             {
//                 "id": "3",
//                 "name": "Enable secure digital signing with encryption, authentication, and compliance standards that protect sensitive documents."
//             },
//             {
//                 "id": "4",
//                 "name": "Create reusable document templates that standardize agreements, reduce preparation time, and ensure consistency across transactions."
//             },
//             {
//                 "id": "5",
//                 "name": "Maintain detailed audit trails that track document activity, signer actions, and timestamps for transparency and compliance verification."
//             }
//         ],
//         "storyId": 35,
//         "storyheadline": "automated-digital-signature-workflows-for-faster-business-approvals",
//         "impact": {
//             "description": "Antrazal delivers secure document automation solutions that accelerate approvals, reduce paperwork, and enhance operational efficiency through fully integrated digital signature ecosystems.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "500K+",
//                     "title": "Documents digitally processed"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "98%",
//                     "name": "Approval cycle time reduced"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "36",
//         "category": "Integration",
//         "name": "Zapier",
//         "slug": "zapier-integration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Zapier_logo-removebg-preview.png",
//         "shortDescription": "Zapier integration services for no-code automation, cross-application connectivity, and streamlined business workflows.",
//         "headline": "Automate workflows across apps without development using powerful no-code integrations.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Connect multiple business applications seamlessly to enable automated data flow and eliminate manual system updates."
//             },
//             {
//                 "id": "2",
//                 "name": "Configure trigger-based automation that instantly initiates workflows when specific events occur across connected platforms."
//             },
//             {
//                 "id": "3",
//                 "name": "Build intelligent workflow logic with conditional paths, filters, and multi-step actions to handle complex business processes."
//             },
//             {
//                 "id": "4",
//                 "name": "Synchronize data between systems in real time to maintain accurate records and ensure consistency across platforms."
//             },
//             {
//                 "id": "5",
//                 "name": "Automate repetitive operational tasks such as notifications, record updates, and approvals to increase productivity and efficiency."
//             }
//         ],
//         "storyId": 36,
//         "storyheadline": "no-code-workflow-automation-for-connected-business-operations",
//         "impact": {
//             "description": "Antrazal enables organizations to automate operations and connect digital tools effortlessly, helping teams improve productivity and scale processes through intelligent integration solutions.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "400+",
//                     "title": "Workflow automations deployed"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "150+",
//                     "name": "Applications successfully connected"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "37",
//         "category": "Integration",
//         "name": "Twilio",
//         "slug": "twilio-integration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Twilio-Logo.png",
//         "shortDescription": "Twilio integration services for real-time communication, messaging automation, and scalable customer engagement solutions.",
//         "headline": "Engage customers instantly through real-time communication across messaging and voice channels.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Automate SMS communications for alerts, reminders, confirmations, and marketing campaigns to improve engagement and response rates."
//             },
//             {
//                 "id": "2",
//                 "name": "Integrate voice APIs that enable calling, IVR systems, call tracking, and real-time communication features within business applications."
//             },
//             {
//                 "id": "3",
//                 "name": "Implement secure OTP verification workflows to authenticate users, protect accounts, and enhance platform security."
//             },
//             {
//                 "id": "4",
//                 "name": "Enable WhatsApp messaging integrations that allow businesses to connect with customers through conversational and interactive messaging."
//             },
//             {
//                 "id": "5",
//                 "name": "Build automated notification workflows that deliver real-time updates across channels based on events, triggers, and user actions."
//             }
//         ],
//         "storyId": 37,
//         "storyheadline": "real-time-customer-communication-with-scalable-messaging-integration",
//         "impact": {
//             "description": "Antrazal provides communication integration solutions that enhance customer engagement, improve responsiveness, and enable businesses to deliver real-time interactions at scale.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "50M+",
//                     "title": "Messages delivered"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "99.9%",
//                     "name": "Message delivery reliability"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "42",
//         "category": "Marketing Automation",
//         "name": "Salesforce Marketing Cloud Next",
//          "pdf_Url":'https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_MarketingCloud.pdf',
//         "logo": "https://backendtestinternal.s3.amazonaws.com/salesforce_marketing-cloud-logo.webp",
//         "slug": "marketing-cloud-next",
//         "shortDescription": "Salesforce Marketing Cloud Next for AI-driven marketing automation, predictive engagement, and intelligent customer journey orchestration.",
//         "headline": "Build intelligent, predictive customer journeys powered by real-time data and AI insights.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Leverage AI-powered segmentation to analyze behavioral, demographic, and engagement data for highly targeted and personalized audience groups."
//             },
//             {
//                 "id": "2",
//                 "name": "Design predictive customer journeys that anticipate user needs, automate interactions, and deliver the right message at the optimal moment."
//             },
//             {
//                 "id": "3",
//                 "name": "Enable real-time targeting that dynamically adapts campaigns based on live customer actions, preferences, and contextual signals."
//             },
//             {
//                 "id": "4",
//                 "name": "Generate unified marketing insights through consolidated analytics dashboards that reveal campaign performance and customer engagement trends."
//             },
//             {
//                 "id": "5",
//                 "name": "Orchestrate cross-channel campaigns across email, mobile, social, web, and advertising platforms for consistent and connected brand experiences."
//             }
//         ],
//         "storyId": 42,
//         "storyheadline": "predictive-ai-driven-marketing-journeys-for-personalized-customer-engagement",
//         "impact": {
//             "description": "Antrazal delivers advanced marketing automation solutions that empower organizations to personalize engagement, optimize campaigns, and drive measurable growth through intelligent data-driven strategies.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "320+",
//                     "title": "Marketing journeys automated"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "180M+",
//                     "name": "Customer interactions optimized"
//                 }
//             ]
//         }
//     },


//     {
//         "id": "43",
//         "category": "Marketing Automation",
//          "pdf_Url":'https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_MarketingCloud.pdf',
//         "name": "Salesforce Marketing Cloud Advanced",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/salesforce_marketing-cloud-logo.webp",
//         "slug": "marketing-cloud-advanced",
//         "shortDescription": "Salesforce Marketing Cloud Advanced for enterprise-grade campaign automation, analytics, and personalized customer engagement at scale.",
//         "headline": "Scale global marketing campaigns with precision, intelligence, and data-driven personalization.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Utilize advanced analytics tools to measure campaign performance, identify trends, and uncover actionable insights for marketing optimization."
//             },
//             {
//                 "id": "2",
//                 "name": "Leverage audience intelligence capabilities that analyze behavioral and demographic data to build highly refined customer segments."
//             },
//             {
//                 "id": "3",
//                 "name": "Orchestrate complex marketing campaigns across channels with automated workflows, scheduling, and intelligent delivery logic."
//             },
//             {
//                 "id": "4",
//                 "name": "Implement personalization engines that tailor messaging, offers, and content dynamically based on real-time customer interactions."
//             },
//             {
//                 "id": "5",
//                 "name": "Monitor performance dashboards that provide real-time visibility into campaign metrics, engagement levels, and ROI outcomes."
//             }
//         ],
//         "storyId": 43,
//         "storyheadline": "enterprise-scale-marketing-automation-for-global-campaign-success",
//         "impact": {
//             "description": "Antrazal delivers enterprise marketing automation solutions that enable organizations to optimize campaigns, enhance personalization, and drive measurable growth through data-driven engagement strategies.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "420+",
//                     "title": "Enterprise campaigns launched"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "210M+",
//                     "name": "Customer interactions analyzed"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "5",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/hubspot.webp",
//         "name": "HubSpot Implementation",
//         "shortDescription": "Transform fragmented leads into a unified, revenue-ready growth engine by connecting CRM, marketing, sales, and service within HubSpot’s powerful ecosystem.",
//         "headline": "Launch a fully integrated growth platform that scales with your business.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Unify contacts, companies, and deals in HubSpot CRM to create a complete 360° customer intelligence hub"
//             },
//             {
//                 "id": "2",
//                 "name": "Automate lead nurturing with behavior-driven workflows, smart segmentation, and personalized email journeys"
//             },
//             {
//                 "id": "3",
//                 "name": "Align marketing, sales, and support teams through customized pipelines, lifecycle stages, and SLA automation"
//             },
//             {
//                 "id": "4",
//                 "name": "Design advanced attribution, forecasting, and performance dashboards with real-time revenue visibility"
//             },
//             {
//                 "id": "5",
//                 "name": "Integrate websites, ad platforms, analytics tools, and business systems using native integrations and scalable APIs"
//             }
//         ],
//         "storyId": 5,
//         "storyheadline": "technology-driven-colloboration-of-university-and-its-students",
//         "impact": {
//             "description": "Antrazal’s strategic, technology-first implementation approach empowers organizations to accelerate growth, optimize customer journeys, and maximize ROI from their HubSpot investment.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "300+",
//                     "title": "HubSpot portals successfully implemented"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "1M+",
//                     "name": "Leads nurtured through intelligent automation workflows"
//                 }
//             ]
//         }
//     },

//     {
//         "id": "45",
//         "category": "Marketing Automation",
//         "name": "Braze",
//         "slug": "braze-platform",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Braze_Logo.svg.png",
//         "shortDescription": "Activate real-time, data-driven customer engagement across channels with a scalable platform built for personalization and growth.",
//         "headline": "Deliver intelligent, cross-channel experiences that convert and retain customers.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Launch real-time push notifications, in-app messages, and omnichannel campaigns from a unified engagement platform"
//             },
//             {
//                 "id": "2",
//                 "name": "Design lifecycle messaging journeys that adapt dynamically to user behavior and engagement signals"
//             },
//             {
//                 "id": "3",
//                 "name": "Segment audiences using live customer data, predictive attributes, and behavioral insights"
//             },
//             {
//                 "id": "4",
//                 "name": "Trigger automated campaigns based on real-time actions, events, and contextual user signals"
//             },
//             {
//                 "id": "5",
//                 "name": "Track campaign performance with advanced analytics dashboards and actionable engagement metrics"
//             }
//         ],
//         "storyId": 45,
//         "storyheadline": "real-time-customer-engagement-transformation",
//         "impact": {
//             "description": "Antrazal enables brands to unlock the full power of Braze through strategic implementation, intelligent automation, and data-driven engagement frameworks that accelerate growth and customer loyalty.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "500M+",
//                     "title": "Personalized messages delivered annually"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "35%",
//                     "name": "Average uplift in customer engagement rates"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "46",
//         "category": "Integration",
//         "name": "Slack",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/slack.png",
//         "slug": "slack",
//         "shortDescription": "Team collaboration integration for notifications and workflows.",
//         "headline": "Connect systems with Slack for real-time collaboration and alerts.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Real-time notifications from CRM, apps, and systems directly into Slack channels."
//             },
//             {
//                 "id": "2",
//                 "name": "Workflow automation that triggers alerts, approvals, and updates across teams."
//             },
//             {
//                 "id": "3",
//                 "name": "Bi-directional integrations to push and pull data between Slack and business platforms."
//             },
//             {
//                 "id": "4",
//                 "name": "Custom bots and slash commands to execute tasks without leaving Slack."
//             },
//             {
//                 "id": "5",
//                 "name": "Secure collaboration with permission controls, audit logs, and enterprise compliance."
//             }
//         ],
//         "storyId": 38,
//         "storyheadline": "real-time-team-collaboration-and-automation",
//         "impact": {
//             "description": "Antrazal helps organizations unify communication and operations by integrating Slack with core business systems, enabling instant alerts, faster decision-making, and streamlined cross-team collaboration.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "150+",
//                     "title": "Slack workflows automated"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "40+",
//                     "name": "Systems integrated with Slack"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "49",
//         "category": "Integration",
//         "name": "Stripe",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/stripe.png",
//         "slug": "stripe",
//         "shortDescription": "Payment gateway integration for secure online transactions.",
//         "headline": "Automate payments, subscriptions, and billing workflows.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Secure payment processing for cards, wallets, and global payment methods."
//             },
//             {
//                 "id": "2",
//                 "name": "Automated subscription billing with invoicing, renewals, and proration logic."
//             },
//             {
//                 "id": "3",
//                 "name": "Real-time payment status sync with CRM, ERP, and backend systems."
//             },
//             {
//                 "id": "4",
//                 "name": "Custom checkout experiences with APIs, webhooks, and hosted payment pages."
//             },
//             {
//                 "id": "5",
//                 "name": "Advanced reporting, reconciliation, and fraud detection tools."
//             }
//         ],
//         "storyId": 39,
//         "storyheadline": "seamless-digital-payments-and-billing-automation",
//         "impact": {
//             "description": "Antrazal enables businesses to streamline payment operations by integrating Stripe with their platforms, delivering faster transactions, improved revenue tracking, and secure global payment experiences.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "500K+",
//                     "title": "Transactions processed"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "60+",
//                     "name": "Payment workflows automated"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "50",
//         "category": "Strategy & Advisory",
//         "name": "Digital Transformation",
//         // "logo":"https://backendtestinternal.s3.amazonaws.com/digital-transformationimage.png",
//         "slug": "digital-transformation",
//         "shortDescription": "Strategic consulting to modernize business processes, technology, and customer experiences.",
//         "headline": "Transform operations, innovation, and growth through digital-first strategies.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Assess current systems, workflows, and digital maturity to identify transformation opportunities."
//             },
//             {
//                 "id": "2",
//                 "name": "Design scalable technology roadmaps aligned with long-term business goals."
//             },
//             {
//                 "id": "3",
//                 "name": "Modernize legacy platforms through cloud migration, automation, and integration."
//             },
//             {
//                 "id": "4",
//                 "name": "Enable data-driven decision making with analytics, dashboards, and AI insights."
//             },
//             {
//                 "id": "5",
//                 "name": "Guide organizational change management, adoption strategy, and digital culture alignment."
//             }
//         ],
//         "storyId": 46,
//         "storyheadline": "accelerating-enterprise-innovation-through-digital-transformation",
//         "impact": {
//             "description": "Antrazal empowers organizations to reinvent operations, enhance agility, and unlock measurable growth through strategic digital transformation initiatives tailored to their industry and goals.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "120+",
//                     "title": "Digital transformation programs delivered"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "3X",
//                     "name": "Average increase in operational efficiency"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "51",
//         "category": "Strategy & Advisory",
//         "name": "Platform Migration",
//         "slug": "platform-migration",
//         // "logo":"https://backendtestinternal.s3.amazonaws.com/IoT-Platform-migration-icon2.png",
//         "shortDescription": "Seamless migration of applications, data, and systems to modern platforms with minimal disruption.",
//         "headline": "Modernize infrastructure and scale confidently with secure platform transitions.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Assess legacy systems, dependencies, and architecture to define the optimal migration strategy."
//             },
//             {
//                 "id": "2",
//                 "name": "Execute secure data migration with validation, integrity checks, and minimal downtime."
//             },
//             {
//                 "id": "3",
//                 "name": "Re-architect applications for cloud, SaaS, or hybrid environments."
//             },
//             {
//                 "id": "4",
//                 "name": "Ensure compliance, security, and performance optimization throughout migration."
//             },
//             {
//                 "id": "5",
//                 "name": "Provide post-migration testing, monitoring, and performance tuning."
//             }
//         ],
//         "storyId": 47,
//         "storyheadline": "seamless-platform-modernization-with-zero-business-disruption",
//         "impact": {
//             "description": "Antrazal enables organizations to transition from legacy systems to modern platforms efficiently and securely, ensuring business continuity, improved scalability, and long-term technology readiness.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "80+",
//                     "title": "Platforms successfully migrated"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "99.9%",
//                     "name": "Data integrity maintained during migrations"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "52",
//         "category": "Strategy & Advisory",
//         "name": "Technology Revamp",
//         // "logo":"https://backendtestinternal.s3.amazonaws.com/technology_revamp_logo.png",
//         "slug": "technology-revamp",
//         "shortDescription": "Modernize legacy systems, architectures, and tech stacks to improve performance, scalability, and innovation readiness.",
//         "headline": "Transform outdated technology into a future-ready digital foundation.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Evaluate existing infrastructure, applications, and architecture to identify modernization opportunities."
//             },
//             {
//                 "id": "2",
//                 "name": "Redesign technology stacks using modern frameworks, cloud platforms, and scalable architectures."
//             },
//             {
//                 "id": "3",
//                 "name": "Optimize system performance, reliability, and security through refactoring and upgrades."
//             },
//             {
//                 "id": "4",
//                 "name": "Implement automation, integrations, and DevOps practices for faster delivery cycles."
//             },
//             {
//                 "id": "5",
//                 "name": "Establish governance, documentation, and future scalability strategies."
//             }
//         ],
//         "storyId": 48,
//         "storyheadline": "revitalizing-technology-for-scalable-digital-growth",
//         "impact": {
//             "description": "Antrazal helps organizations revitalize their technology ecosystem by modernizing legacy systems, improving efficiency, and enabling innovation with scalable, secure, and future-ready digital solutions.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "60+",
//                     "title": "Systems modernized"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "3x",
//                     "name": "Average performance improvement"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "53",
//         "category": "Strategy & Advisory",
//         "name": "Data Governance and Security",
//         // "logo":"https://backendtestinternal.s3.amazonaws.com/data_governance_enhanced.png",
//         "slug": "data-governance-security",
//         "shortDescription": "Establish structured data governance frameworks and security strategies to protect, manage, and maximize the value of enterprise data.",
//         "headline": "Secure, govern, and control your data with confidence.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Design enterprise data governance frameworks including ownership models, policies, and stewardship processes."
//             },
//             {
//                 "id": "2",
//                 "name": "Implement data classification, access controls, and encryption standards to ensure compliance and protection."
//             },
//             {
//                 "id": "3",
//                 "name": "Establish data quality monitoring, validation rules, and lifecycle management processes."
//             },
//             {
//                 "id": "4",
//                 "name": "Deploy risk assessment, audit readiness, and regulatory compliance strategies across systems."
//             },
//             {
//                 "id": "5",
//                 "name": "Enable secure data sharing and integration while maintaining visibility, traceability, and governance controls."
//             }
//         ],
//         "storyId": 49,
//         "storyheadline": "building-trust-through-secure-and-governed-data-ecosystems",
//         "impact": {
//             "description": "Antrazal empowers organizations to safeguard critical data assets while improving transparency, compliance, and decision-making through robust governance frameworks and advanced security strategies.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "100%",
//                     "title": "Policy-driven data access control"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "70%",
//                     "name": "Reduction in data risk exposure"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "54",
//         "category": "Design",
//         "name": "User Experience",
//         // "logo":"https://backendtestinternal.s3.amazonaws.com/bigstock-Ux-User-Experience-User-Inte-274189435.PNG",
//         "slug": "user-experience",
//         "shortDescription": "Design intuitive, user-centered digital experiences that enhance engagement, usability, and customer satisfaction across platforms.",
//         "headline": "Create seamless experiences users love and trust.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Conduct user research, persona creation, and journey mapping to understand audience needs and behaviors."
//             },
//             {
//                 "id": "2",
//                 "name": "Design wireframes, prototypes, and interaction flows that optimize usability and accessibility."
//             },
//             {
//                 "id": "3",
//                 "name": "Implement responsive and mobile-first interface designs tailored for multi-device experiences."
//             },
//             {
//                 "id": "4",
//                 "name": "Perform usability testing, feedback analysis, and iterative improvements for continuous enhancement."
//             },
//             {
//                 "id": "5",
//                 "name": "Align UX strategy with business goals to increase engagement, retention, and conversion rates."
//             }
//         ],
//         "storyId": 50,
//         "storyheadline": "designing-intuitive-digital-experiences-that-drive-engagement",
//         "impact": {
//             "description": "Antrazal crafts user-first digital experiences that blend design thinking, usability principles, and strategic insight to deliver intuitive interfaces that improve satisfaction and business performance.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "85%",
//                     "title": "Increase in user engagement"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "60%",
//                     "name": "Improvement in task completion rates"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "55",
//         "category": "Design",
//         "name": "Design Thinking",
//         "slug": "design-thinking",
//         // "logo":"https://backendtestinternal.s3.amazonaws.com/design_thinking_nobg.png",
//         "shortDescription": "Human-centered innovation approach that solves complex problems through creativity, empathy, and rapid experimentation.",
//         "headline": "Turn ideas into impactful solutions through user-driven innovation.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Conduct empathy research and stakeholder workshops to deeply understand user needs, pain points, and motivations."
//             },
//             {
//                 "id": "2",
//                 "name": "Define problem statements and opportunity areas using structured ideation and insight synthesis frameworks."
//             },
//             {
//                 "id": "3",
//                 "name": "Facilitate collaborative brainstorming sessions that generate innovative, practical, and scalable solution concepts."
//             },
//             {
//                 "id": "4",
//                 "name": "Build rapid prototypes and validate ideas through iterative testing and real user feedback loops."
//             },
//             {
//                 "id": "5",
//                 "name": "Align business goals, technology feasibility, and user desirability to ensure solutions are viable, valuable, and implementable."
//             }
//         ],
//         "storyId": 51,
//         "storyheadline": "human-centered-innovation-for-smarter-solutions",
//         "impact": {
//             "description": "Antrazal applies structured design thinking methodologies to help organizations innovate confidently, reduce risk, and deliver solutions that truly resonate with users and stakeholders.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "5x",
//                     "title": "Faster solution validation cycles"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "70%",
//                     "name": "Improvement in solution adoption rates"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "56",
//         "category": "Design",
//         "name": "Prototyping & Wireframing",
//         // "logo":"https://backendtestinternal.s3.amazonaws.com/mix-icon-for-wireframing-prototyping-vector.jpg",
//         "slug": "prototyping-&-wireframing",
//         "shortDescription": "Visualize product concepts and user flows before development through structured design prototypes.",
//         "headline": "Validate ideas faster with interactive design blueprints.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Create low-fidelity wireframes to map layouts, navigation paths, and information architecture."
//             },
//             {
//                 "id": "2",
//                 "name": "Develop interactive prototypes that simulate real user experiences and system behavior."
//             },
//             {
//                 "id": "3",
//                 "name": "Test usability early with stakeholder and user feedback to refine designs before development."
//             },
//             {
//                 "id": "4",
//                 "name": "Design scalable UI structures aligned with brand standards and accessibility best practices."
//             },
//             {
//                 "id": "5",
//                 "name": "Collaborate with product and engineering teams to translate concepts into build-ready specifications."
//             }
//         ],
//         "storyId": 52,
//         "storyheadline": "transforming-ideas-into-validated-design-experiences",
//         "impact": {
//             "description": "Antrazal accelerates product innovation by transforming concepts into validated visual models, reducing development risk and ensuring solutions meet real user expectations before launch.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "60%",
//                     "title": "Reduction in design revision cycles"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "3X",
//                     "name": "Faster stakeholder approval timelines"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "57",
//         "category": "DevOps",
//         "name": "AWS",
//         "slug": "aws",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Amazon_Web_Services_Logo.svg.png",
//         "shortDescription": "Scalable cloud infrastructure and DevOps solutions powered by AWS for secure, high-performance applications.",
//         "headline": "Build, deploy, and scale faster with cloud-native DevOps on AWS.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Design and implement secure, scalable AWS cloud architectures tailored to application performance, compliance, and business growth requirements."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate infrastructure provisioning using Infrastructure as Code to ensure consistency, repeatability, and rapid environment setup."
//             },
//             {
//                 "id": "3",
//                 "name": "Establish CI/CD pipelines that streamline build, test, and deployment processes for faster and more reliable releases."
//             },
//             {
//                 "id": "4",
//                 "name": "Monitor systems proactively with logging, alerts, and performance analytics to maintain uptime and operational stability."
//             },
//             {
//                 "id": "5",
//                 "name": "Optimize cloud costs and resource utilization through performance tuning, scaling strategies, and governance best practices."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "accelerating-cloud-innovation-with-aws-devops",
//         "impact": {
//             "description": "Antrazal enables organizations to modernize infrastructure and accelerate delivery through AWS-powered DevOps solutions that enhance scalability, reliability, and deployment speed while maintaining enterprise-grade security.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "70%",
//                     "title": "Faster deployment cycles achieved"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "99.9%",
//                     "name": "Infrastructure uptime maintained"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "58",
//         "category": "DevOps",
//         "name": "Copado",
//         "slug": "copado",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Copado%20Logo.png",
//         "shortDescription": "Salesforce DevOps platform for automated releases, testing, and compliant deployments.",
//         "headline": "Accelerate Salesforce delivery with intelligent DevOps automation.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Automate end-to-end Salesforce release pipelines with version control, continuous integration, and continuous delivery workflows."
//             },
//             {
//                 "id": "2",
//                 "name": "Enable collaborative development with user story tracking, environment management, and deployment visibility."
//             },
//             {
//                 "id": "3",
//                 "name": "Implement automated testing frameworks that validate code quality, performance, and compliance before release."
//             },
//             {
//                 "id": "4",
//                 "name": "Ensure secure and compliant deployments using governance controls, audit trails, and approval workflows."
//             },
//             {
//                 "id": "5",
//                 "name": "Monitor release performance metrics and optimize delivery cycles through real-time DevOps analytics."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "streamlining-salesforce-delivery-with-devops-automation",
//         "impact": {
//             "description": "Antrazal empowers organizations to modernize Salesforce development with Copado-driven DevOps automation, reducing release risks, accelerating deployment speed, and improving overall software quality across environments.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "80%",
//                     "title": "Faster deployment cycles"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "65%",
//                     "name": "Reduction in release failures"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "59",
//         "category": "DevOps",
//         "name": "Gearset",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/gearset-logo-freelogovectors.net_-180x39.png",
//         "slug": "gearset",
//         "shortDescription": "Salesforce DevOps and release management platform for faster, safer deployments.",
//         "headline": "Automate deployments and manage releases with confidence.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Automate Salesforce deployments with CI/CD pipelines that reduce manual effort and release risk."
//             },
//             {
//                 "id": "2",
//                 "name": "Compare orgs and track metadata differences to maintain consistency across environments."
//             },
//             {
//                 "id": "3",
//                 "name": "Monitor deployments in real time with detailed logs, alerts, and rollback capabilities."
//             },
//             {
//                 "id": "4",
//                 "name": "Enforce quality standards using automated testing, validation checks, and compliance rules."
//             },
//             {
//                 "id": "5",
//                 "name": "Manage version control integrations to streamline collaboration between development and operations teams."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "streamlined-salesforce-releases-with-devops-automation",
//         "impact": {
//             "description": "Antrazal empowers organizations to modernize their Salesforce DevOps processes using Gearset, enabling faster releases, improved deployment reliability, and greater development team productivity through automation and intelligent release management.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "80%",
//                     "title": "Faster deployment cycles"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "90%",
//                     "name": "Reduction in release errors"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "60",
//         "category": "AI",
//         "name": "Chat Agents",
//         // "logo":"https://backendtestinternal.s3.amazonaws.com/chat-bot-minimalistic-logo-design-artificial-intelligence-business-identity-concept-vector_418020-506.PNG",
//         "slug": "chat-agents",
//         "shortDescription": "Intelligent conversational agents that automate support, engagement, and business workflows.",
//         "headline": "Deliver instant, human-like interactions with AI-powered chat automation.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Build conversational AI agents capable of handling customer queries, internal requests, and guided workflows autonomously."
//             },
//             {
//                 "id": "2",
//                 "name": "Train chat agents using business knowledge bases, documents, and real-time data sources for accurate responses."
//             },
//             {
//                 "id": "3",
//                 "name": "Integrate chatbots across websites, apps, CRMs, and messaging platforms for unified engagement experiences."
//             },
//             {
//                 "id": "4",
//                 "name": "Enable contextual understanding, sentiment detection, and intent recognition for smarter conversations."
//             },
//             {
//                 "id": "5",
//                 "name": "Track performance analytics and conversation insights to continuously optimize response accuracy and efficiency."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "ai-conversational-agents-transforming-digital-engagement",
//         "impact": {
//             "description": "Antrazal empowers organizations with intelligent chat agents that streamline communication, reduce operational workload, and enhance customer satisfaction through real-time automated interactions.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "70%",
//                     "title": "Reduction in support response time"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "24/7",
//                     "name": "Automated customer interaction availability"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "61",
//         "category": "AI",
//         "name": "Voice Agents",
//         // "logo":"https://backendtestinternal.s3.amazonaws.com/ai-voice-generator-icon-vector-600nw-2534404855.webp",
//         "slug": "voice-agents",
//         "shortDescription": "AI-powered conversational voice agents that automate calls, support interactions, and real-time responses.",
//         "headline": "Enable intelligent voice conversations that work 24/7.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Deploy AI voice agents capable of handling inbound and outbound calls with natural language understanding."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate customer support, appointment booking, reminders, and notifications through voice interactions."
//             },
//             {
//                 "id": "3",
//                 "name": "Integrate voice systems with CRM, ticketing, and backend platforms for real-time data access."
//             },
//             {
//                 "id": "4",
//                 "name": "Train conversational models using business-specific datasets for contextual and accurate responses."
//             },
//             {
//                 "id": "5",
//                 "name": "Monitor conversations with analytics dashboards to optimize performance, quality, and engagement."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "ai-voice-automation-for-intelligent-customer-engagement",
//         "impact": {
//             "description": "Antrazal empowers organizations with AI-driven voice automation that enhances customer interactions, reduces operational workload, and delivers scalable, real-time communication experiences.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "80%",
//                     "title": "Reduction in manual call handling"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "24/7",
//                     "name": "Automated voice support availability"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "62",
//         "category": "AI",
//         "name": "Sales Agents (Sentiment)",
//         "slug": "sales-agents-(sentiment)",
//         "shortDescription": "AI-powered sales agents that analyze customer sentiment to improve engagement, conversions, and relationship outcomes.",
//         "headline": "Understand buyer emotions and respond with precision using AI-driven sentiment intelligence.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Analyze customer tone, intent, and sentiment across calls, chats, and emails to understand real-time buyer mindset."
//             },
//             {
//                 "id": "2",
//                 "name": "Provide sales teams with live sentiment insights and recommended responses to improve communication effectiveness."
//             },
//             {
//                 "id": "3",
//                 "name": "Detect buying signals, hesitation patterns, and objections using machine learning models trained on conversation data."
//             },
//             {
//                 "id": "4",
//                 "name": "Automate follow-up prioritization based on emotional engagement scores and likelihood-to-convert predictions."
//             },
//             {
//                 "id": "5",
//                 "name": "Generate performance analytics that help leaders optimize sales scripts, coaching strategies, and deal approaches."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "ai-driven-sales-intelligence-powered-by-sentiment-analysis",
//         "impact": {
//             "description": "Antrazal enables organizations to close deals faster and build stronger customer relationships by deploying AI sentiment intelligence that reveals buyer intent, guides sales conversations, and enhances decision-making with actionable emotional insights.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "35%",
//                     "title": "Increase in sales conversion rates"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "50%+",
//                     "name": "Improvement in engagement quality scores"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "63",
//         "category": "AI",
//         "name": "AI Service Agents",
//         "slug": "ai-service-agents",
//         "shortDescription": "AI-powered service agents that automate customer support, issue resolution, and operational assistance.",
//         "headline": "Deliver intelligent support with autonomous service agents.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Deploy AI service agents that handle customer queries, requests, and support tasks automatically across channels."
//             },
//             {
//                 "id": "2",
//                 "name": "Enable natural language understanding to interpret user intent and provide accurate contextual responses."
//             },
//             {
//                 "id": "3",
//                 "name": "Integrate agents with CRM, ticketing, and backend systems for real-time data access and action execution."
//             },
//             {
//                 "id": "4",
//                 "name": "Continuously learn from interactions to improve response accuracy, efficiency, and customer satisfaction."
//             },
//             {
//                 "id": "5",
//                 "name": "Provide analytics dashboards to monitor performance, resolution rates, and automation effectiveness."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "ai-driven-support-automation-for-modern-service-experiences",
//         "impact": {
//             "description": "Antrazal helps organizations scale support operations with AI-powered service agents that automate resolutions, reduce response times, and enhance customer satisfaction through intelligent assistance.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "70%",
//                     "title": "Faster response times"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "65%",
//                     "name": "Reduction in manual support workload"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "64",
//         "category": "Snowflake",
//         "name": "Snowflake Implementation & Migration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Snowflake_Logo.svg.png",
//         "slug": "snowflake-implementation-&-migration",
//         "shortDescription": "Implement and migrate data platforms to Snowflake for scalable, secure, and high-performance analytics.",
//         "headline": "Modernize your data ecosystem with seamless cloud migration.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Design and deploy Snowflake architectures optimized for performance, scalability, and cost efficiency."
//             },
//             {
//                 "id": "2",
//                 "name": "Migrate legacy databases, warehouses, and on-prem systems to Snowflake with minimal downtime and data integrity assurance."
//             },
//             {
//                 "id": "3",
//                 "name": "Build secure data pipelines and automated ingestion frameworks for real-time and batch processing."
//             },
//             {
//                 "id": "4",
//                 "name": "Implement governance, role-based access, and compliance controls to ensure enterprise-grade data security."
//             },
//             {
//                 "id": "5",
//                 "name": "Enable advanced analytics, BI integrations, and data sharing capabilities for cross-department insights."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "scalable-cloud-data-foundations-for-modern-enterprises",
//         "impact": {
//             "description": "Antrazal empowers organizations to unlock the full potential of their data by implementing Snowflake solutions that enhance scalability, streamline analytics, and deliver faster, insight-driven decision making.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "10TB+",
//                     "title": "Data successfully migrated"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "5X",
//                     "name": "Improvement in query performance"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "65",
//         "category": "Snowflake",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Snowflake_Logo.svg.png",
//         "name": "Data Engineering & Pipelines",
//         "slug": "snowflake-data-engineering-&-pipelines",
//         "shortDescription": "Build scalable Snowflake data pipelines that transform raw data into analytics-ready insights.",
//         "headline": "Power real-time decisions with automated data pipelines.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Design and implement robust ETL and ELT pipelines that ingest, transform, and load structured and unstructured data efficiently."
//             },
//             {
//                 "id": "2",
//                 "name": "Develop scalable data architectures optimized for Snowflake performance, cost efficiency, and high-volume workloads."
//             },
//             {
//                 "id": "3",
//                 "name": "Automate data workflows using orchestration frameworks to ensure reliable scheduling, monitoring, and error handling."
//             },
//             {
//                 "id": "4",
//                 "name": "Enable real-time and batch data streaming integrations from multiple sources including APIs, applications, and databases."
//             },
//             {
//                 "id": "5",
//                 "name": "Implement data quality validation, governance policies, and transformation logic to deliver clean and analytics-ready datasets."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "scalable-data-foundations-for-modern-analytics",
//         "impact": {
//             "description": "Antrazal empowers organizations to unlock the full value of their data by building high-performance Snowflake pipelines that ensure accuracy, scalability, and real-time accessibility for advanced analytics and strategic decision-making.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "10TB+",
//                     "title": "Data processed daily"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "99.9%",
//                     "name": "Pipeline reliability achieved"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "66",
//         "category": "Snowflake",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Snowflake_Logo.svg.png",
//         "name": "Data Warehousing & BI Enablement",
//         "slug": "data-warehousing-&-bi-enablement",
//         "shortDescription": "Modern cloud data warehousing and business intelligence solutions for unified analytics and reporting.",
//         "headline": "Transform raw data into actionable intelligence with scalable cloud analytics.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Design and implement scalable cloud data warehouses optimized for performance, cost efficiency, and real-time analytics."
//             },
//             {
//                 "id": "2",
//                 "name": "Integrate structured and unstructured data from multiple sources into a centralized, analytics-ready repository."
//             },
//             {
//                 "id": "3",
//                 "name": "Enable advanced BI dashboards and visualization layers that provide real-time insights for faster decision-making."
//             },
//             {
//                 "id": "4",
//                 "name": "Optimize data models, query performance, and storage strategies to ensure high-speed reporting and analytics."
//             },
//             {
//                 "id": "5",
//                 "name": "Implement secure data governance, role-based access, and compliance frameworks for enterprise-grade data protection."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "building-a-scalable-foundation-for-enterprise-analytics",
//         "impact": {
//             "description": "Antrazal empowers organizations with modern data warehousing and BI capabilities that unify data, accelerate analytics, and enable leadership teams to make confident, data-driven decisions at scale.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "10TB+",
//                     "title": "Enterprise data consolidated"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "5X",
//                     "name": "Faster analytics query performance"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "67",
//         "category": "MS Dynamics",
//         "name": "Dynamics 365 CRM Implementation",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Microsoft_Dynamics_365_Logo_(2021%C3%A2%C2%80%C2%93present).svg.png",
//         "slug": "dynamics-365-crm-implementation",
//         "shortDescription": "Implement Microsoft Dynamics 365 CRM to unify sales, marketing, and customer service operations on a scalable platform.",
//         "headline": "Accelerate customer engagement with a fully integrated CRM ecosystem.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Design and deploy tailored Dynamics 365 CRM architectures aligned with business processes and growth strategies."
//             },
//             {
//                 "id": "2",
//                 "name": "Configure custom entities, workflows, dashboards, and automation rules to streamline operations and improve productivity."
//             },
//             {
//                 "id": "3",
//                 "name": "Integrate ERP systems, marketing platforms, and third-party applications for seamless cross-system data flow."
//             },
//             {
//                 "id": "4",
//                 "name": "Migrate legacy data securely with validation, cleansing, and transformation for accurate CRM adoption."
//             },
//             {
//                 "id": "5",
//                 "name": "Enable user adoption through training, documentation, and performance optimization for long-term success."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "connected-crm-ecosystem-for-smarter-customer-management",
//         "impact": {
//             "description": "Antrazal empowers organizations to maximize CRM value through strategic Dynamics 365 implementation, delivering unified customer insights, streamlined operations, and scalable digital infrastructure for sustainable growth.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "120+",
//                     "title": "CRM implementations delivered"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "65%",
//                     "name": "Increase in operational efficiency"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "68",
//         "category": "MS Dynamics",
//         "name": "Dynamics 365 ERP Solutions",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Microsoft_Dynamics_365_Logo_(2021%C3%A2%C2%80%C2%93present).svg.png",
//         "slug": "dynamics-365-erp-solutions",
//         "shortDescription": "Integrated ERP solutions to streamline finance, operations, supply chain, and business performance.",
//         "headline": "Unify operations with intelligent, scalable ERP systems.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Implement end-to-end ERP systems that connect finance, procurement, inventory, and operations in one unified platform."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate financial processes including accounting, reporting, budgeting, and compliance management."
//             },
//             {
//                 "id": "3",
//                 "name": "Optimize supply chain visibility with real-time inventory tracking, demand forecasting, and logistics insights."
//             },
//             {
//                 "id": "4",
//                 "name": "Enable data-driven decisions through built-in analytics, dashboards, and predictive intelligence."
//             },
//             {
//                 "id": "5",
//                 "name": "Customize ERP workflows and integrations to align with business processes and industry requirements."
//             }
//         ],
//         "storyId": 53,
//         "storyheadline": "connected-enterprise-operations-with-intelligent-erp",
//         "impact": {
//             "description": "Antrazal empowers organizations to modernize operations with Dynamics ERP solutions that improve financial visibility, streamline workflows, and create scalable foundations for long-term growth.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "40%",
//                     "title": "Increase in operational efficiency"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "2X",
//                     "name": "Faster financial reporting cycles"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "69",
//         "category": "MS Dynamics",
//         "name": "Customization & Integration",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Microsoft_Dynamics_365_Logo_(2021%C3%A2%C2%80%C2%93present).svg.png",
//         "slug": "customization-&-integration",
//         "shortDescription": "Tailored Dynamics solutions with seamless integrations across your business ecosystem.",
//         "headline": "Adapt your platform to your processes, not the other way around.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Customize modules, workflows, and entities to match unique business processes and operational needs."
//             },
//             {
//                 "id": "2",
//                 "name": "Integrate Dynamics with CRMs, ERPs, payment systems, and third-party applications for unified data flow."
//             },
//             {
//                 "id": "3",
//                 "name": "Develop custom plugins, APIs, and automation scripts to extend platform functionality."
//             },
//             {
//                 "id": "4",
//                 "name": "Implement real-time data synchronization to eliminate silos and ensure system consistency."
//             },
//             {
//                 "id": "5",
//                 "name": "Optimize performance, security, and scalability while maintaining compliance and system stability."
//             }
//         ],
//         "storyId": 54,
//         "storyheadline": "building-connected-systems-with-tailored-dynamics-solutions",
//         "impact": {
//             "description": "Antrazal helps organizations unlock the full potential of Dynamics platforms through strategic customization and intelligent integrations that streamline operations, enhance productivity, and create a unified digital ecosystem.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "150+",
//                     "title": "Custom integrations delivered"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "99.9%",
//                     "name": "System data synchronization accuracy"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "70",
//         "category": "MS Dynamics",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Microsoft_Dynamics_365_Logo_(2021%C3%A2%C2%80%C2%93present).svg.png",
//         "name": "Support & Optimization Services",
//         "slug": "support-&-optimization-services",
//         "shortDescription": "Continuous support and performance optimization to keep your Dynamics platform efficient, secure, and scalable.",
//         "headline": "Maximize platform performance with proactive support and optimization.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Provide ongoing technical support, monitoring, and troubleshooting to ensure uninterrupted system performance."
//             },
//             {
//                 "id": "2",
//                 "name": "Optimize workflows, automations, and configurations to improve speed, usability, and productivity."
//             },
//             {
//                 "id": "3",
//                 "name": "Conduct system health audits and performance tuning to maintain peak operational efficiency."
//             },
//             {
//                 "id": "4",
//                 "name": "Implement updates, patches, and enhancements while ensuring stability and compliance."
//             },
//             {
//                 "id": "5",
//                 "name": "Deliver strategic recommendations and continuous improvements aligned with evolving business needs."
//             }
//         ],
//         "storyId": 55,
//         "storyheadline": "ensuring-continuous-performance-and-platform-excellence",
//         "impact": {
//             "description": "Antrazal ensures long-term platform success by providing proactive support and optimization services that enhance system reliability, boost user productivity, and keep your Dynamics environment aligned with business growth.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "99.8%",
//                     "title": "Average platform uptime maintained"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "45%",
//                     "name": "Reduction in performance-related issues"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "70",
//         "category": "MS Dynamics",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Microsoft_Dynamics_365_Logo_(2021%C3%A2%C2%80%C2%93present).svg.png",
//         "name": "Power Platform Enablement",
//         "slug": "power-platform-enablement",
//         "shortDescription": "Enable rapid innovation with low-code tools for apps, automation, analytics, and intelligent business solutions.",
//         "headline": "Build, automate, and analyze faster with Microsoft Power Platform.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Develop custom business applications quickly using low-code tools tailored to operational requirements."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate workflows and repetitive tasks with intelligent process automation across systems and teams."
//             },
//             {
//                 "id": "3",
//                 "name": "Create real-time dashboards and reports that provide actionable insights for faster decision-making."
//             },
//             {
//                 "id": "4",
//                 "name": "Integrate data sources, APIs, and enterprise platforms to enable seamless information flow."
//             },
//             {
//                 "id": "5",
//                 "name": "Empower teams with self-service tools while maintaining governance, security, and compliance standards."
//             }
//         ],
//         "storyId": 56,
//         "storyheadline": "accelerating-innovation-through-low-code-platform-enablement",
//         "impact": {
//             "description": "Antrazal empowers organizations to innovate rapidly with Power Platform solutions that streamline processes, reduce development time, and enable teams to build scalable digital tools without heavy coding.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "70%",
//                     "title": "Faster application development cycles"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "3X",
//                     "name": "Increase in workflow automation efficiency"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "57",
//         "category": "Other",
//         "name": "Zoho",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/ZOHO_New.png",
//         "slug": "zoho",
//         "shortDescription": "Unified business platform to manage sales, marketing, finance, support, and operations from one ecosystem.",
//         "headline": "Run your entire business seamlessly with connected Zoho applications.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Implement and configure Zoho applications tailored to sales, marketing, finance, HR, and customer operations."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate business workflows, approvals, notifications, and data synchronization across departments."
//             },
//             {
//                 "id": "3",
//                 "name": "Customize modules, fields, dashboards, and reports to align with your organization’s processes."
//             },
//             {
//                 "id": "4",
//                 "name": "Integrate Zoho with third-party systems, payment platforms, CRMs, and enterprise tools for unified data flow."
//             },
//             {
//                 "id": "5",
//                 "name": "Enable real-time analytics and performance insights to support strategic decisions and growth."
//             }
//         ],
//         "storyId": 57,
//         "storyheadline": "building-connected-business-operations-with-zoho-ecosystem",
//         "impact": {
//             "description": "Antrazal helps organizations unlock the full potential of Zoho’s ecosystem by creating connected, automated, and scalable digital environments that improve efficiency, visibility, and business performance.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "120+",
//                     "title": "Zoho implementations delivered"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "65%",
//                     "name": "Average workflow automation improvement"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "71",
//         "category": "other",
//         "name": "ServiceNow",
//         "logo": 'https://backendtestinternal.s3.amazonaws.com/ServiceNow_logo.svg.png',
//         "slug": "servicenow",
//         "shortDescription": "Enterprise workflow automation platform for IT, HR, operations, and customer service management.",
//         "headline": "Streamline enterprise operations with intelligent digital workflows.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Implement unified service management solutions that connect IT, HR, customer support, and operations on a single platform."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate enterprise workflows and approvals to eliminate manual processes and increase operational efficiency."
//             },
//             {
//                 "id": "3",
//                 "name": "Design custom applications and modules tailored to organizational processes and compliance requirements."
//             },
//             {
//                 "id": "4",
//                 "name": "Enable real-time visibility into performance, incidents, and service metrics through intelligent dashboards."
//             },
//             {
//                 "id": "5",
//                 "name": "Integrate enterprise systems and data sources to create seamless cross-departmental service experiences."
//             }
//         ],
//         "storyId": 57,
//         "storyheadline": "transforming-enterprise-operations-with-unified-workflows",
//         "impact": {
//             "description": "Antrazal helps organizations modernize operations with ServiceNow solutions that automate workflows, enhance service delivery, and provide real-time operational intelligence for scalable digital transformation.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "65%",
//                     "title": "Reduction in manual service processes"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "2.5X",
//                     "name": "Improvement in workflow efficiency"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "72",
//         "category": "Other",
//         "name": "MS Dynamics",
//         "logo": "https://backendtestinternal.s3.amazonaws.com/Microsoft_Dynamics_365_Logo_(2021%C3%A2%C2%80%C2%93present).svg%20(1).png",
//         "slug": "ms-dynamics",
//         "shortDescription": "Comprehensive Microsoft Dynamics solutions for CRM, ERP, automation, and enterprise process optimization.",
//         "headline": "Transform business operations with a unified intelligent platform.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Implement end-to-end Dynamics solutions that unify sales, service, finance, and operations within a single ecosystem."
//             },
//             {
//                 "id": "2",
//                 "name": "Automate business workflows and processes to increase efficiency, reduce manual effort, and improve accuracy."
//             },
//             {
//                 "id": "3",
//                 "name": "Integrate Dynamics with enterprise applications, data platforms, and third-party systems for seamless connectivity."
//             },
//             {
//                 "id": "4",
//                 "name": "Deliver real-time analytics and reporting dashboards that support data-driven decision making."
//             },
//             {
//                 "id": "5",
//                 "name": "Customize modules, interfaces, and automation logic tailored to organizational workflows and industry needs."
//             }
//         ],
//         "storyId": 57,
//         "storyheadline": "modernizing-business-systems-with-unified-dynamics-platform",
//         "impact": {
//             "description": "Antrazal enables organizations to streamline operations, enhance visibility, and accelerate growth through strategically implemented Dynamics solutions that align technology with business performance goals.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "55%",
//                     "title": "Improvement in process efficiency"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "2.5X",
//                     "name": "Increase in operational visibility"
//                 }
//             ]
//         }
//     },
//     {
//         "id": "73",
//         "category": "Other",
//         "name": "Azure",
//         "logo": 'https://backendtestinternal.s3.amazonaws.com/Microsoft_Azure_Logo.svg.png',
//         "slug": "azure",
//         "shortDescription": "Scalable cloud infrastructure and enterprise solutions powered by Microsoft Azure.",
//         "headline": "Build, deploy, and scale securely with intelligent cloud innovation.",
//         "capabilities": [
//             {
//                 "id": "1",
//                 "name": "Design and deploy secure cloud infrastructure including virtual machines, networking, storage, and Kubernetes environments."
//             },
//             {
//                 "id": "2",
//                 "name": "Migrate on-premise applications and workloads to Azure with minimal downtime and optimized performance."
//             },
//             {
//                 "id": "3",
//                 "name": "Implement cloud-native architectures using microservices, containers, and serverless computing."
//             },
//             {
//                 "id": "4",
//                 "name": "Leverage Azure AI, analytics, and data services for advanced business intelligence and predictive insights."
//             },
//             {
//                 "id": "5",
//                 "name": "Ensure enterprise-grade security, compliance, backup, disaster recovery, and cost optimization strategies."
//             }
//         ],
//         "storyId": 57,
//         "storyheadline": "scalable-secure-and-intelligent-cloud-transformation",
//         "impact": {
//             "description": "Antrazal enables organizations to harness the full potential of Azure by delivering secure, scalable, and high-performance cloud environments that accelerate innovation, reduce infrastructure costs, and support long-term digital growth.",
//             "items": [
//                 {
//                     "id": "1",
//                     "measure": "99.9%",
//                     "title": "Cloud uptime reliability delivered"
//                 },
//                 {
//                     "id": "2",
//                     "measure": "40%",
//                     "name": "Reduction in infrastructure costs"
//                 }
//             ]
//         }
//     }
// ];


export const servicesData = [


    {
        "id": "1",
         "pdf_Url":"https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_HealthCloud.pdf",
        "name": "Salesforce Health Cloud",
        "shortDescription": "Salesforce Health Cloud for patient, providers and medications management",
        "headline": "Enable easy accessibility to care for your patients and PHI to the providers.",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo_1.png",
        "capabilities": [
            {
                "id": "1",
                "name": "Set up highly personalized patient care management with unified profiles, care plans, clinical insights, and engagement timelines that allow providers to deliver tailored treatment experiences."
            },
            {
                "id": "2",
                "name": "Securely store and manage PHI across HIPAA and HL7-compliant clinical data models ensuring regulatory compliance, privacy protection, and standardized interoperability."
            },
            {
                "id": "3",
                "name": "Build a comprehensive health timeline combining visits, medications, lab results, and provider notes to give care teams a complete 360-degree medical history."
            },
            {
                "id": "4",
                "name": "Synchronize CRM and EHR systems bi-directionally to maintain real-time data accuracy, eliminate duplicate records, and improve clinical decision making."
            },
            {
                "id": "5",
                "name": "Develop fully connected healthcare ecosystems integrating devices, apps, portals, and providers for seamless patient engagement and coordinated care delivery."
            }
        ],
        "storyId": 1,
        'storyheadline': 'connected-crm-ehr-and-website-to-help-patients-and-providers',
        "impact": {
            "description": "Antrazal's extensive technical and industry tailored solutioning human-centric approach can help achieve your digitalization goals for the future.",
            "items": [
                {
                    "id": "1",
                    "measure": "10+",
                    "title": "Health and Phrama digitalization"
                },
                {
                    "id": "2",
                    "measure": "50+",
                    "name": "Customer/Providers Portal developed"
                }
            ]
        }
    },
    {
        "id": "12",
        "category": "Salesforce",
        "name": "Salesforce Data Cloud",
        "slug": "salesforce-data-cloud",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo2.webp",
        "shortDescription": "Salesforce Data Cloud for real-time unified customer data, identity resolution, and AI-powered insights.",
        "headline": "Transform fragmented data into a single intelligent customer profile for smarter decisions.",
        "capabilities": [
            {
                "id": "1",
                "name": "Resolve identities across multiple systems and channels using advanced matching algorithms to create accurate, persistent, and unified customer records."
            },
            {
                "id": "2",
                "name": "Ingest streaming and batch data from diverse sources such as CRM, web, mobile, IoT, and third-party platforms for real-time data activation."
            },
            {
                "id": "3",
                "name": "Build comprehensive unified profiles that consolidate behavioral, transactional, and demographic data for a complete 360-degree customer view."
            },
            {
                "id": "4",
                "name": "Prepare AI-ready datasets that enable predictive analytics, personalization engines, and automation workflows powered by trusted data."
            },
            {
                "id": "5",
                "name": "Implement robust governance, consent, and compliance tools to ensure data quality, privacy, and secure enterprise-grade data management."
            }
        ],
        "storyId": 12,
        "storyheadline": "unified-real-time-customer-data-platform-for-personalization-and-analytics",
        "impact": {
            "description": "Antrazal's extensive technical and industry tailored solutioning human-centric approach can help achieve your digitalization goals for the future.",
            "items": [
                {
                    "id": "1",
                    "measure": "15+",
                    "title": "Enterprise data platforms implemented"
                },
                {
                    "id": "2",
                    "measure": "100+",
                    "name": "Data integrations and pipelines delivered"
                }
            ]
        }
    },
    {
        "id": "2",
         "pdf_Url":"https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_RevenueCloud.pdf",
        "name": "Salesforce Revenue Cloud (CPQ)",
        "shortDescription": "Salesforce Revenue Cloud (CPQ) for intelligent quoting, pricing, billing, inventory, and subscription lifecycle management.",
        "headline": "Configure fast, guided, and error-proof personalized product bundles, pricing, and discounts with automation.",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo3.png",
        "capabilities": [
            {
                "id": "1",
                "name": "Centralize and digitize every product, bundle, price book, and discount schedule within a unified system that ensures consistency, scalability, and easy management across sales channels."
            },
            {
                "id": "2",
                "name": "Embed intelligent selling logic and automated validation rules that prevent configuration errors, enforce pricing policies, and automatically protect deal margins."
            },
            {
                "id": "3",
                "name": "Accelerate the generation of branded, accurate quotes and legally binding contracts using automated templates, approvals, and one-click document creation."
            },
            {
                "id": "4",
                "name": "Seamlessly convert accepted quotes into revenue-tracked orders, assets, invoices, and subscription records for complete lifecycle visibility and operational efficiency."
            },
            {
                "id": "5",
                "name": "Continuously monitor performance metrics, analyze deal trends, and refine pricing strategies using data insights to maximize profitability and long-term ROI."
            }
        ],
        "storyId": 2,
        "storyheadline": "smarter-revenue-verified-at-every-stage",
        "impact": {
            "description": "Antrazal empowers organizations to maximize revenue efficiency with Salesforce Revenue Cloud (CPQ) through intelligent configuration, automated pricing, and streamlined quote-to-cash processes that accelerate deal velocity and ensure margin accuracy.",
            "items": [
                {
                    "id": "1",
                    "measure": "5000+",
                    "title": "Products and Bundles configured"
                },
                {
                    "id": "2",
                    "measure": "50+",
                    "name": "External integrations"
                }
            ]
        }
    },

    {
        "id": "14",
        "category": "Salesforce",
        "name": "Salesforce Agentforce",
        "slug": "salesforce-agentforce",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo4.webp",
        "shortDescription": "Salesforce Agentforce for AI-powered autonomous agents, workflow automation, and intelligent operational productivity.",
        "headline": "Increase productivity with intelligent automation driven by autonomous AI agents.",
        "capabilities": [
            {
                "id": "1",
                "name": "Deploy autonomous AI agents capable of executing tasks, making decisions, and completing business processes with minimal human intervention."
            },
            {
                "id": "2",
                "name": "Leverage predictive intelligence to anticipate tasks, recommend next actions, and proactively optimize workflows across teams and systems."
            },
            {
                "id": "3",
                "name": "Orchestrate complex workflows across departments, applications, and data sources to streamline operations and eliminate manual bottlenecks."
            },
            {
                "id": "4",
                "name": "Empower employees with AI copilots that assist in real time, providing contextual insights, suggestions, and automation support for faster execution."
            },
            {
                "id": "5",
                "name": "Gain deep operational insights through analytics and monitoring tools that track performance, efficiency, and automation impact across processes."
            }
        ],
        "storyId": 14,
        "storyheadline": "ai-powered-automation-for-smarter-business-operations",
        "impact": {
            "description": "Antrazal enables organizations to scale productivity and operational intelligence with Salesforce Agentforce by deploying autonomous AI agents, orchestrating workflows, and delivering real-time decision support that drives measurable efficiency and faster business outcomes.",
            "items": [
                {
                    "id": "1",
                    "measure": "200+",
                    "title": "Automated workflows deployed"
                },
                {
                    "id": "2",
                    "measure": "70+",
                    "name": "AI-driven process implementations"
                }
            ]
        }
    },

    {
        "id": "3",
        "pdf_Url":'https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_MarketingCloud.pdf',
        "name": "Salesforce Marketing Cloud",
        "shortDescription": "Salesforce Marketing Cloud for personalized omnichannel campaigns, audience engagement, and data-driven marketing performance.",
        "headline": "Deliver timely, personalized cross-channel communications that maximize engagement and conversions.",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo5.webp",
        "capabilities": [
            {
                "id": "1",
                "name": "Create advanced audience segmentation using behavioral, demographic, and interaction data to precisely target customers with relevant messaging."
            },
            {
                "id": "2",
                "name": "Execute consent-driven, insight-led omnichannel marketing campaigns that respect preferences while improving engagement effectiveness."
            },
            {
                "id": "3",
                "name": "Design and automate multi-touchpoint customer journeys across lifecycle stages to nurture leads and strengthen long-term relationships."
            },
            {
                "id": "4",
                "name": "Send emails, SMS, and push notifications at AI-optimized times to increase open rates, response rates, and campaign performance."
            },
            {
                "id": "5",
                "name": "Integrate marketing data, analytics, and reporting dashboards to continuously refine strategies and drive measurable ROI improvements."
            }
        ],
        "storyId": 3,
        "storyheadline": "timely-notifications-to-the-patients-and-gps",
        "impact": {
            "description": "Antrazal empowers organizations with intelligent marketing ecosystems that enhance customer engagement, optimize campaign performance, and accelerate growth through data-driven decision making.",
            "items": [
                {
                    "id": "1",
                    "measure": "250+",
                    "title": "Customer journeys built"
                },
                {
                    "id": "2",
                    "measure": "20M+",
                    "name": "Target audience managed"
                }
            ]
        }
    },

    {
        "id": "16",
        "category": "Salesforce",
        "name": "Salesforce Field Service",
        "pdf_Url": "https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_MobileApp_And_FieldServiceLightning.pdf",
        "slug": "salesforce-field-service",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo6.webp",
        "shortDescription": "Salesforce Field Service for intelligent scheduling, technician productivity, and real-time service operations management.",
        "headline": "Deliver faster, smarter on-site service experiences with optimized scheduling and dispatch automation.",
        "capabilities": [
            {
                "id": "1",
                "name": "Implement intelligent scheduling tools that automatically assign the right technician based on skills, availability, priority, and service location."
            },
            {
                "id": "2",
                "name": "Optimize service routes using real-time traffic, distance, and job urgency data to reduce travel time and increase daily job completion rates."
            },
            {
                "id": "3",
                "name": "Equip technicians with a powerful mobile app that provides work orders, customer history, checklists, and offline capabilities for seamless field execution."
            },
            {
                "id": "4",
                "name": "Track jobs in real time with live status updates, automated notifications, and visibility dashboards for improved coordination and customer satisfaction."
            },
            {
                "id": "5",
                "name": "Enable predictive maintenance by analyzing asset data and service history to anticipate issues before failures occur and reduce downtime."
            }
        ],
        "storyId": 16,
        "storyheadline": "optimized-field-operations-with-real-time-service-visibility",
        "impact": {
            "description": "Antrazal delivers intelligent field service solutions that enhance technician efficiency, improve customer satisfaction, and streamline service operations through automation and real-time insights.",
            "items": [
                {
                    "id": "1",
                    "measure": "120+",
                    "title": "Field service processes automated"
                },
                {
                    "id": "2",
                    "measure": "85+",
                    "name": "Technician mobility solutions deployed"
                }
            ]
        }
    },

    {
        "id": "4",
         "pdf_Url":"https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_ExperienceCloud.pdf",
        "name": "Salesforce Experience Cloud",
        "shortDescription": "Salesforce Experience Cloud for scalable digital portals, partner ecosystems, and interactive global engagement platforms.",
        "headline": "Power technology-driven global engagement with dynamic, data-rich digital experiences.",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo7.webp",
        "capabilities": [
            {
                "id": "1",
                "name": "Launch high-performance Lightning Web Runtime (LWR) sites engineered for global scale, fast load times, and enterprise-grade reliability."
            },
            {
                "id": "2",
                "name": "Design interactive and visually rich geographic experiences using D3.js-powered world maps for intuitive exploration of global data."
            },
            {
                "id": "3",
                "name": "Deliver real-time KPI visualization through dynamic ChartJS dashboards that transform complex datasets into actionable insights."
            },
            {
                "id": "4",
                "name": "Surface secure API-connected data with advanced filtering, drill-down views, and role-based access for personalized user experiences."
            },
            {
                "id": "5",
                "name": "Build modular Lightning Web Components that enable scalable architecture, rapid enhancements, and consistent user interface design."
            },
            {
                "id": "6",
                "name": "Optimize mobile-first performance to ensure seamless accessibility, responsiveness, and usability across devices and global regions."
            },
            {
                "id": "7",
                "name": "Enable centralized visibility into global program performance with unified dashboards that support strategic decision making."
            }
        ],
        "storyId": 4,
        "storyheadline": "elevating-global-impact-visibility-with-a-dynamic-lightning-web-runtime-platform",
        "impact": {
            "description": "Antrazal builds scalable digital experience platforms that empower organizations to visualize global impact, enhance stakeholder engagement, and drive data-informed decisions with confidence.",
            "items": [
                {
                    "id": "1",
                    "measure": "100+",
                    "title": "Countries visualized"
                },
                {
                    "id": "2",
                    "measure": "10+",
                    "name": "Scalable platform architecture delivered"
                }
            ]
        }
    },

    {
        "id": "18",
        "category": "Salesforce",
        "name": "Salesforce Service Cloud",
        "slug": "salesforce-service-cloud",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo_8.webp",
        "shortDescription": "Salesforce Service Cloud for AI-powered customer support, intelligent case management, and seamless service experiences.",
        "headline": "Resolve customer cases faster with smart automation, AI insights, and unified support channels.",
        "capabilities": [
            {
                "id": "1",
                "name": "Deliver omnichannel support across phone, email, chat, social media, and messaging platforms from a single unified service console."
            },
            {
                "id": "2",
                "name": "Automatically route cases using AI-driven logic that matches customer needs with the most qualified agents for faster resolution."
            },
            {
                "id": "3",
                "name": "Launch scalable self-service portals that empower customers to find answers, submit requests, and track cases independently."
            },
            {
                "id": "4",
                "name": "Build intelligent knowledge bases that provide agents and customers with accurate, searchable information for consistent support delivery."
            },
            {
                "id": "5",
                "name": "Analyze service performance using real-time dashboards and reports to improve efficiency, satisfaction scores, and operational outcomes."
            }
        ],
        "storyId": 18,
        "storyheadline": "ai-driven-customer-service-transformation-for-faster-resolution",
        "impact": {
            "description": "Antrazal implements intelligent customer service solutions that enhance support efficiency, elevate customer satisfaction, and streamline service operations through automation and actionable insights.",
            "items": [
                {
                    "id": "1",
                    "measure": "300+",
                    "title": "Support workflows automated"
                },
                {
                    "id": "2",
                    "measure": "90+",
                    "name": "Service process optimizations delivered"
                }
            ]
        }
    },

    {
        "id": "19",
        "category": "Salesforce",
        "name": "Salesforce Implementation",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo28.png",
        "slug": "salesforce-implementation",
        "shortDescription": "Salesforce implementation services for scalable CRM architecture, automation, integrations, and optimized business processes.",
        "headline": "Launch faster with a scalable, secure, and future-ready Salesforce architecture.",
        "capabilities": [
            {
                "id": "1",
                "name": "Design robust and scalable system architectures tailored to business requirements, ensuring performance, security, and long-term platform stability."
            },
            {
                "id": "2",
                "name": "Configure custom objects, fields, relationships, and data models to accurately represent business processes and operational workflows."
            },
            {
                "id": "3",
                "name": "Build automation flows, approval processes, and business logic that streamline operations, reduce manual effort, and improve productivity."
            },
            {
                "id": "4",
                "name": "Integrate Salesforce with external systems, APIs, and third-party platforms to enable seamless data synchronization and unified operations."
            },
            {
                "id": "5",
                "name": "Provide end-to-end training, testing, deployment, and post-launch support to ensure successful adoption and long-term platform success."
            }
        ],
        "storyId": 19,
        "storyheadline": "scalable-salesforce-platform-launch-for-digital-transformation",
        "impact": {
            "description": "Antrazal delivers tailored Salesforce implementation solutions that align technology with business goals, accelerate digital transformation, and ensure long-term platform success.",
            "items": [
                {
                    "id": "1",
                    "measure": "150+",
                    "title": "Salesforce environments deployed"
                },
                {
                    "id": "2",
                    "measure": "120+",
                    "name": "Enterprise integrations delivered"
                }
            ]
        }
    },

    {
        "id": "21",
        "category": "Healthcare Solutions",
        "name": "EDI Processor",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServcieLogo9.jpg",
        "slug": "edi-processor",
        "shortDescription": "EDI Processor for automated healthcare claims processing, transaction validation, and compliant data exchange workflows.",
        "headline": "Streamline healthcare transactions and reduce manual errors with intelligent EDI automation.",
        "capabilities": [
            {
                "id": "1",
                "name": "Parse complex EDI transaction files accurately, converting structured healthcare data into standardized, system-ready formats for processing."
            },
            {
                "id": "2",
                "name": "Automate claims processing workflows to accelerate approvals, reduce manual intervention, and improve operational efficiency across billing cycles."
            },
            {
                "id": "3",
                "name": "Apply advanced validation rules to detect inconsistencies, missing data, and formatting issues before submission to ensure data accuracy."
            },
            {
                "id": "4",
                "name": "Support industry-compliant healthcare transaction formats including HIPAA-standard EDI structures for secure and reliable data exchange."
            },
            {
                "id": "5",
                "name": "Implement intelligent error handling and reporting mechanisms that identify, log, and resolve transaction failures quickly and efficiently."
            }
        ],
        "storyId": 21,
        "storyheadline": "automated-healthcare-edi-processing-for-faster-claims-and-compliance",
        "impact": {
            "description": "Antrazal delivers advanced healthcare automation solutions that enhance claims accuracy, ensure compliance, and accelerate transaction processing through intelligent EDI technologies.",
            "items": [
                {
                    "id": "1",
                    "measure": "5M+",
                    "title": "Healthcare transactions processed"
                },
                {
                    "id": "2",
                    "measure": "99.9%",
                    "name": "Data processing accuracy achieved"
                }
            ]
        }
    },
    {
        "id": "22",
        "category": "Healthcare Solutions",
        "name": "FHIR & HL7 Integration",
        "slug": "fhir-hl7-integration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo10.webp",
        "shortDescription": "FHIR and HL7 integration services for secure healthcare interoperability, clinical data exchange, and connected health systems.",
        "headline": "Connect clinical systems securely with standardized, real-time healthcare data interoperability.",
        "capabilities": [
            {
                "id": "1",
                "name": "Develop and implement FHIR-based APIs that enable standardized, scalable, and secure access to healthcare data across applications and platforms."
            },
            {
                "id": "2",
                "name": "Configure HL7 interfaces to facilitate seamless communication between EHRs, laboratory systems, billing platforms, and clinical applications."
            },
            {
                "id": "3",
                "name": "Synchronize clinical data across multiple healthcare systems to ensure accurate, consistent, and up-to-date patient information."
            },
            {
                "id": "4",
                "name": "Enable real-time data exchange between providers, partners, and healthcare platforms for faster decision-making and coordinated care delivery."
            },
            {
                "id": "5",
                "name": "Ensure full healthcare compliance with industry standards and regulatory requirements while maintaining data security and patient privacy."
            }
        ],
        "storyId": 22,
        "storyheadline": "secure-healthcare-interoperability-with-real-time-clinical-data-integration",
        "impact": {
            "description": "Antrazal provides advanced interoperability solutions that unify healthcare systems, enhance data accessibility, and support efficient, secure clinical collaboration across digital ecosystems.",
            "items": [
                {
                    "id": "1",
                    "measure": "80+",
                    "title": "Healthcare systems integrated"
                },
                {
                    "id": "2",
                    "measure": "10M+",
                    "name": "Clinical records synchronized"
                }
            ]
        }
    },


    {
        "id": "31",
        "category": "Integration",
        "name": "MuleSoft",
        "slug": "mulesoft-integration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo11.webp",
        "shortDescription": "MuleSoft integration services for enterprise APIs, system connectivity, and scalable data orchestration across platforms.",
        "headline": "Connect systems, data, and applications through secure and scalable integration architecture.",
        "capabilities": [
            {
                "id": "1",
                "name": "Design robust, reusable APIs using best practices and governance standards to enable scalable and consistent digital integration strategies."
            },
            {
                "id": "2",
                "name": "Integrate enterprise systems, legacy platforms, cloud applications, and databases to create seamless, unified business workflows."
            },
            {
                "id": "3",
                "name": "Orchestrate data flows across multiple services and platforms to ensure real-time synchronization, accuracy, and operational efficiency."
            },
            {
                "id": "4",
                "name": "Implement middleware architectures that simplify complex integrations, reduce system dependencies, and improve overall performance."
            },
            {
                "id": "5",
                "name": "Secure endpoints and APIs using authentication, encryption, and policy enforcement mechanisms to protect enterprise data and services."
            }
        ],
        "storyId": 31,
        "storyheadline": "scalable-enterprise-integration-with-api-led-connectivity",
        "impact": {
            "description": "Antrazal delivers enterprise-grade integration solutions that unify systems, accelerate data exchange, and enable organizations to innovate faster through connected digital ecosystems.",
            "items": [
                {
                    "id": "1",
                    "measure": "250+",
                    "title": "APIs designed and deployed"
                },
                {
                    "id": "2",
                    "measure": "120+",
                    "name": "Systems successfully integrated"
                }
            ]
        }
    },

    {
        "id": "32",
        "category": "Integration",
        "name": "Celigo",
        "slug": "celigo-integration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo27.webp",
        "shortDescription": "Celigo integration services for automating workflows, connecting SaaS applications, and streamlining cross-platform data synchronization.",
        "headline": "Automate business processes seamlessly by connecting your SaaS systems in real time.",
        "capabilities": [
            {
                "id": "1",
                "name": "Utilize prebuilt connectors to rapidly integrate popular SaaS applications, reducing implementation time and simplifying system connectivity."
            },
            {
                "id": "2",
                "name": "Automate complex workflows across business platforms to eliminate manual tasks, improve efficiency, and ensure consistent operational execution."
            },
            {
                "id": "3",
                "name": "Monitor integration processes with intelligent error detection and alerts that quickly identify issues and prevent workflow disruptions."
            },
            {
                "id": "4",
                "name": "Configure advanced data mapping rules to transform, standardize, and synchronize information between multiple systems accurately."
            },
            {
                "id": "5",
                "name": "Enable real-time data synchronization across connected applications to maintain up-to-date records and support informed decision making."
            }
        ],
        "storyId": 32,
        "storyheadline": "seamless-saas-integration-for-automated-business-operations",
        "impact": {
            "description": "Antrazal provides intelligent integration solutions that streamline application connectivity, automate business workflows, and enhance operational visibility across digital ecosystems.",
            "items": [
                {
                    "id": "1",
                    "measure": "180+",
                    "title": "Integrations deployed"
                },
                {
                    "id": "2",
                    "measure": "95+",
                    "name": "Automated workflows implemented"
                }
            ]
        }
    },

    {
        "id": "33",
        "category": "Integration",
        "name": "QuickBooks",
        "slug": "quickbooks-integration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo26.webp",
        "shortDescription": "QuickBooks integration services for automated accounting synchronization, financial visibility, and seamless CRM connectivity.",
        "headline": "Synchronize financial data automatically to streamline accounting and business operations.",
        "capabilities": [
            {
                "id": "1",
                "name": "Synchronize invoices between accounting and business systems to ensure accurate billing records and eliminate duplicate manual entry."
            },
            {
                "id": "2",
                "name": "Track payments in real time with automated updates that reflect transaction statuses across connected platforms."
            },
            {
                "id": "3",
                "name": "Sync customer data across CRM, ERP, and accounting tools to maintain consistent records and improve financial accuracy."
            },
            {
                "id": "4",
                "name": "Generate comprehensive financial reports by consolidating accounting data into unified dashboards for informed decision making."
            },
            {
                "id": "5",
                "name": "Create automation rules that trigger workflows such as invoice generation, payment reminders, and reconciliation processes."
            }
        ],
        "storyId": 33,
        "storyheadline": "automated-financial-data-sync-for-accurate-accounting-operations",
        "impact": {
            "description": "Antrazal delivers reliable financial integration solutions that enhance accounting accuracy, improve operational efficiency, and provide real-time financial visibility across business systems.",
            "items": [
                {
                    "id": "1",
                    "measure": "300+",
                    "title": "Accounting integrations completed"
                },
                {
                    "id": "2",
                    "measure": "99.8%",
                    "name": "Financial data accuracy achieved"
                }
            ]
        }
    },

    {
        "id": "34",
        "category": "Integration",
        "name": "NetSuite",
        "slug": "netsuite-integration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo25.webp",
        "shortDescription": "NetSuite integration services for unified ERP connectivity, automated operations, and synchronized financial and business data.",
        "headline": "Connect your ERP seamlessly with the entire business ecosystem for real-time operational visibility.",
        "capabilities": [
            {
                "id": "1",
                "name": "Synchronize ERP data across CRM, eCommerce, logistics, and finance systems to maintain accurate and consistent enterprise records."
            },
            {
                "id": "2",
                "name": "Automate order processing workflows that seamlessly transfer sales data between platforms for faster fulfillment and reduced manual work."
            },
            {
                "id": "3",
                "name": "Enable real-time inventory synchronization across warehouses, storefronts, and supply chain systems to prevent stock discrepancies."
            },
            {
                "id": "4",
                "name": "Streamline finance workflows by integrating billing, accounting, and payment systems for efficient financial operations and reporting."
            },
            {
                "id": "5",
                "name": "Deliver analytics-ready data feeds that consolidate operational insights and support strategic decision making across departments."
            }
        ],
        "storyId": 34,
        "storyheadline": "connected-erp-ecosystem-for-streamlined-business-operations",
        "impact": {
            "description": "Antrazal provides enterprise ERP integration solutions that unify business processes, enhance operational transparency, and empower organizations with real-time data-driven insights.",
            "items": [
                {
                    "id": "1",
                    "measure": "140+",
                    "title": "ERP integrations delivered"
                },
                {
                    "id": "2",
                    "measure": "60+",
                    "name": "Business systems connected"
                }
            ]
        }
    },

    {
        "id": "35",
        "category": "Integration",
        "name": "DocuSign",
        "slug": "docusign-integration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLgoo25.webp",
        "shortDescription": "DocuSign integration services for automated digital signatures, contract workflows, and secure document management.",
        "headline": "Automate document approvals and contract processes with secure, compliant digital signing.",
        "capabilities": [
            {
                "id": "1",
                "name": "Automate signature collection processes that send documents for signing, track completion status, and store finalized records without manual effort."
            },
            {
                "id": "2",
                "name": "Streamline contract workflows by integrating approval steps, notifications, and document routing across business systems."
            },
            {
                "id": "3",
                "name": "Enable secure digital signing with encryption, authentication, and compliance standards that protect sensitive documents."
            },
            {
                "id": "4",
                "name": "Create reusable document templates that standardize agreements, reduce preparation time, and ensure consistency across transactions."
            },
            {
                "id": "5",
                "name": "Maintain detailed audit trails that track document activity, signer actions, and timestamps for transparency and compliance verification."
            }
        ],
        "storyId": 35,
        "storyheadline": "automated-digital-signature-workflows-for-faster-business-approvals",
        "impact": {
            "description": "Antrazal delivers secure document automation solutions that accelerate approvals, reduce paperwork, and enhance operational efficiency through fully integrated digital signature ecosystems.",
            "items": [
                {
                    "id": "1",
                    "measure": "500K+",
                    "title": "Documents digitally processed"
                },
                {
                    "id": "2",
                    "measure": "98%",
                    "name": "Approval cycle time reduced"
                }
            ]
        }
    },

    {
        "id": "36",
        "category": "Integration",
        "name": "Zapier",
        "slug": "zapier-integration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo24.png",
        "shortDescription": "Zapier integration services for no-code automation, cross-application connectivity, and streamlined business workflows.",
        "headline": "Automate workflows across apps without development using powerful no-code integrations.",
        "capabilities": [
            {
                "id": "1",
                "name": "Connect multiple business applications seamlessly to enable automated data flow and eliminate manual system updates."
            },
            {
                "id": "2",
                "name": "Configure trigger-based automation that instantly initiates workflows when specific events occur across connected platforms."
            },
            {
                "id": "3",
                "name": "Build intelligent workflow logic with conditional paths, filters, and multi-step actions to handle complex business processes."
            },
            {
                "id": "4",
                "name": "Synchronize data between systems in real time to maintain accurate records and ensure consistency across platforms."
            },
            {
                "id": "5",
                "name": "Automate repetitive operational tasks such as notifications, record updates, and approvals to increase productivity and efficiency."
            }
        ],
        "storyId": 36,
        "storyheadline": "no-code-workflow-automation-for-connected-business-operations",
        "impact": {
            "description": "Antrazal enables organizations to automate operations and connect digital tools effortlessly, helping teams improve productivity and scale processes through intelligent integration solutions.",
            "items": [
                {
                    "id": "1",
                    "measure": "400+",
                    "title": "Workflow automations deployed"
                },
                {
                    "id": "2",
                    "measure": "150+",
                    "name": "Applications successfully connected"
                }
            ]
        }
    },

    {
        "id": "37",
        "category": "Integration",
        "name": "Twilio",
        "slug": "twilio-integration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo23.png",
        "shortDescription": "Twilio integration services for real-time communication, messaging automation, and scalable customer engagement solutions.",
        "headline": "Engage customers instantly through real-time communication across messaging and voice channels.",
        "capabilities": [
            {
                "id": "1",
                "name": "Automate SMS communications for alerts, reminders, confirmations, and marketing campaigns to improve engagement and response rates."
            },
            {
                "id": "2",
                "name": "Integrate voice APIs that enable calling, IVR systems, call tracking, and real-time communication features within business applications."
            },
            {
                "id": "3",
                "name": "Implement secure OTP verification workflows to authenticate users, protect accounts, and enhance platform security."
            },
            {
                "id": "4",
                "name": "Enable WhatsApp messaging integrations that allow businesses to connect with customers through conversational and interactive messaging."
            },
            {
                "id": "5",
                "name": "Build automated notification workflows that deliver real-time updates across channels based on events, triggers, and user actions."
            }
        ],
        "storyId": 37,
        "storyheadline": "real-time-customer-communication-with-scalable-messaging-integration",
        "impact": {
            "description": "Antrazal provides communication integration solutions that enhance customer engagement, improve responsiveness, and enable businesses to deliver real-time interactions at scale.",
            "items": [
                {
                    "id": "1",
                    "measure": "50M+",
                    "title": "Messages delivered"
                },
                {
                    "id": "2",
                    "measure": "99.9%",
                    "name": "Message delivery reliability"
                }
            ]
        }
    },

    {
        "id": "42",
        "category": "Marketing Automation",
        "name": "Salesforce Marketing Cloud Next",
         "pdf_Url":'https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_MarketingCloud.pdf',
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo5.webp",
        "slug": "marketing-cloud-next",
        "shortDescription": "Salesforce Marketing Cloud Next for AI-driven marketing automation, predictive engagement, and intelligent customer journey orchestration.",
        "headline": "Build intelligent, predictive customer journeys powered by real-time data and AI insights.",
        "capabilities": [
            {
                "id": "1",
                "name": "Leverage AI-powered segmentation to analyze behavioral, demographic, and engagement data for highly targeted and personalized audience groups."
            },
            {
                "id": "2",
                "name": "Design predictive customer journeys that anticipate user needs, automate interactions, and deliver the right message at the optimal moment."
            },
            {
                "id": "3",
                "name": "Enable real-time targeting that dynamically adapts campaigns based on live customer actions, preferences, and contextual signals."
            },
            {
                "id": "4",
                "name": "Generate unified marketing insights through consolidated analytics dashboards that reveal campaign performance and customer engagement trends."
            },
            {
                "id": "5",
                "name": "Orchestrate cross-channel campaigns across email, mobile, social, web, and advertising platforms for consistent and connected brand experiences."
            }
        ],
        "storyId": 42,
        "storyheadline": "predictive-ai-driven-marketing-journeys-for-personalized-customer-engagement",
        "impact": {
            "description": "Antrazal delivers advanced marketing automation solutions that empower organizations to personalize engagement, optimize campaigns, and drive measurable growth through intelligent data-driven strategies.",
            "items": [
                {
                    "id": "1",
                    "measure": "320+",
                    "title": "Marketing journeys automated"
                },
                {
                    "id": "2",
                    "measure": "180M+",
                    "name": "Customer interactions optimized"
                }
            ]
        }
    },


    {
        "id": "43",
        "category": "Marketing Automation",
         "pdf_Url":'https://backendtestinternal.s3.amazonaws.com/Antrazal_Salesforce_MarketingCloud.pdf',
        "name": "Salesforce Marketing Cloud Advanced",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo5.webp",
        "slug": "marketing-cloud-advanced",
        "shortDescription": "Salesforce Marketing Cloud Advanced for enterprise-grade campaign automation, analytics, and personalized customer engagement at scale.",
        "headline": "Scale global marketing campaigns with precision, intelligence, and data-driven personalization.",
        "capabilities": [
            {
                "id": "1",
                "name": "Utilize advanced analytics tools to measure campaign performance, identify trends, and uncover actionable insights for marketing optimization."
            },
            {
                "id": "2",
                "name": "Leverage audience intelligence capabilities that analyze behavioral and demographic data to build highly refined customer segments."
            },
            {
                "id": "3",
                "name": "Orchestrate complex marketing campaigns across channels with automated workflows, scheduling, and intelligent delivery logic."
            },
            {
                "id": "4",
                "name": "Implement personalization engines that tailor messaging, offers, and content dynamically based on real-time customer interactions."
            },
            {
                "id": "5",
                "name": "Monitor performance dashboards that provide real-time visibility into campaign metrics, engagement levels, and ROI outcomes."
            }
        ],
        "storyId": 43,
        "storyheadline": "enterprise-scale-marketing-automation-for-global-campaign-success",
        "impact": {
            "description": "Antrazal delivers enterprise marketing automation solutions that enable organizations to optimize campaigns, enhance personalization, and drive measurable growth through data-driven engagement strategies.",
            "items": [
                {
                    "id": "1",
                    "measure": "420+",
                    "title": "Enterprise campaigns launched"
                },
                {
                    "id": "2",
                    "measure": "210M+",
                    "name": "Customer interactions analyzed"
                }
            ]
        }
    },

    {
        "id": "5",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo22.webp",
        "name": "HubSpot Implementation",
        "shortDescription": "Transform fragmented leads into a unified, revenue-ready growth engine by connecting CRM, marketing, sales, and service within HubSpot’s powerful ecosystem.",
        "headline": "Launch a fully integrated growth platform that scales with your business.",
        "capabilities": [
            {
                "id": "1",
                "name": "Unify contacts, companies, and deals in HubSpot CRM to create a complete 360° customer intelligence hub"
            },
            {
                "id": "2",
                "name": "Automate lead nurturing with behavior-driven workflows, smart segmentation, and personalized email journeys"
            },
            {
                "id": "3",
                "name": "Align marketing, sales, and support teams through customized pipelines, lifecycle stages, and SLA automation"
            },
            {
                "id": "4",
                "name": "Design advanced attribution, forecasting, and performance dashboards with real-time revenue visibility"
            },
            {
                "id": "5",
                "name": "Integrate websites, ad platforms, analytics tools, and business systems using native integrations and scalable APIs"
            }
        ],
        "storyId": 5,
        "storyheadline": "technology-driven-colloboration-of-university-and-its-students",
        "impact": {
            "description": "Antrazal’s strategic, technology-first implementation approach empowers organizations to accelerate growth, optimize customer journeys, and maximize ROI from their HubSpot investment.",
            "items": [
                {
                    "id": "1",
                    "measure": "300+",
                    "title": "HubSpot portals successfully implemented"
                },
                {
                    "id": "2",
                    "measure": "1M+",
                    "name": "Leads nurtured through intelligent automation workflows"
                }
            ]
        }
    },

    {
        "id": "45",
        "category": "Marketing Automation",
        "name": "Braze",
        "slug": "braze-platform",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo21.png",
        "shortDescription": "Activate real-time, data-driven customer engagement across channels with a scalable platform built for personalization and growth.",
        "headline": "Deliver intelligent, cross-channel experiences that convert and retain customers.",
        "capabilities": [
            {
                "id": "1",
                "name": "Launch real-time push notifications, in-app messages, and omnichannel campaigns from a unified engagement platform"
            },
            {
                "id": "2",
                "name": "Design lifecycle messaging journeys that adapt dynamically to user behavior and engagement signals"
            },
            {
                "id": "3",
                "name": "Segment audiences using live customer data, predictive attributes, and behavioral insights"
            },
            {
                "id": "4",
                "name": "Trigger automated campaigns based on real-time actions, events, and contextual user signals"
            },
            {
                "id": "5",
                "name": "Track campaign performance with advanced analytics dashboards and actionable engagement metrics"
            }
        ],
        "storyId": 45,
        "storyheadline": "real-time-customer-engagement-transformation",
        "impact": {
            "description": "Antrazal enables brands to unlock the full power of Braze through strategic implementation, intelligent automation, and data-driven engagement frameworks that accelerate growth and customer loyalty.",
            "items": [
                {
                    "id": "1",
                    "measure": "500M+",
                    "title": "Personalized messages delivered annually"
                },
                {
                    "id": "2",
                    "measure": "35%",
                    "name": "Average uplift in customer engagement rates"
                }
            ]
        }
    },
    {
        "id": "46",
        "category": "Integration",
        "name": "Slack",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo20.png",
        "slug": "slack",
        "shortDescription": "Team collaboration integration for notifications and workflows.",
        "headline": "Connect systems with Slack for real-time collaboration and alerts.",
        "capabilities": [
            {
                "id": "1",
                "name": "Real-time notifications from CRM, apps, and systems directly into Slack channels."
            },
            {
                "id": "2",
                "name": "Workflow automation that triggers alerts, approvals, and updates across teams."
            },
            {
                "id": "3",
                "name": "Bi-directional integrations to push and pull data between Slack and business platforms."
            },
            {
                "id": "4",
                "name": "Custom bots and slash commands to execute tasks without leaving Slack."
            },
            {
                "id": "5",
                "name": "Secure collaboration with permission controls, audit logs, and enterprise compliance."
            }
        ],
        "storyId": 38,
        "storyheadline": "real-time-team-collaboration-and-automation",
        "impact": {
            "description": "Antrazal helps organizations unify communication and operations by integrating Slack with core business systems, enabling instant alerts, faster decision-making, and streamlined cross-team collaboration.",
            "items": [
                {
                    "id": "1",
                    "measure": "150+",
                    "title": "Slack workflows automated"
                },
                {
                    "id": "2",
                    "measure": "40+",
                    "name": "Systems integrated with Slack"
                }
            ]
        }
    },
    {
        "id": "49",
        "category": "Integration",
        "name": "Stripe",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo19.png",
        "slug": "stripe",
        "shortDescription": "Payment gateway integration for secure online transactions.",
        "headline": "Automate payments, subscriptions, and billing workflows.",
        "capabilities": [
            {
                "id": "1",
                "name": "Secure payment processing for cards, wallets, and global payment methods."
            },
            {
                "id": "2",
                "name": "Automated subscription billing with invoicing, renewals, and proration logic."
            },
            {
                "id": "3",
                "name": "Real-time payment status sync with CRM, ERP, and backend systems."
            },
            {
                "id": "4",
                "name": "Custom checkout experiences with APIs, webhooks, and hosted payment pages."
            },
            {
                "id": "5",
                "name": "Advanced reporting, reconciliation, and fraud detection tools."
            }
        ],
        "storyId": 39,
        "storyheadline": "seamless-digital-payments-and-billing-automation",
        "impact": {
            "description": "Antrazal enables businesses to streamline payment operations by integrating Stripe with their platforms, delivering faster transactions, improved revenue tracking, and secure global payment experiences.",
            "items": [
                {
                    "id": "1",
                    "measure": "500K+",
                    "title": "Transactions processed"
                },
                {
                    "id": "2",
                    "measure": "60+",
                    "name": "Payment workflows automated"
                }
            ]
        }
    },
    {
        "id": "50",
        "category": "Strategy & Advisory",
        "name": "Digital Transformation",
       "slug": "digital-transformation",
        "shortDescription": "Strategic consulting to modernize business processes, technology, and customer experiences.",
        "headline": "Transform operations, innovation, and growth through digital-first strategies.",
        "capabilities": [
            {
                "id": "1",
                "name": "Assess current systems, workflows, and digital maturity to identify transformation opportunities."
            },
            {
                "id": "2",
                "name": "Design scalable technology roadmaps aligned with long-term business goals."
            },
            {
                "id": "3",
                "name": "Modernize legacy platforms through cloud migration, automation, and integration."
            },
            {
                "id": "4",
                "name": "Enable data-driven decision making with analytics, dashboards, and AI insights."
            },
            {
                "id": "5",
                "name": "Guide organizational change management, adoption strategy, and digital culture alignment."
            }
        ],
        "storyId": 46,
        "storyheadline": "accelerating-enterprise-innovation-through-digital-transformation",
        "impact": {
            "description": "Antrazal empowers organizations to reinvent operations, enhance agility, and unlock measurable growth through strategic digital transformation initiatives tailored to their industry and goals.",
            "items": [
                {
                    "id": "1",
                    "measure": "120+",
                    "title": "Digital transformation programs delivered"
                },
                {
                    "id": "2",
                    "measure": "3X",
                    "name": "Average increase in operational efficiency"
                }
            ]
        }
    },
    {
        "id": "51",
        "category": "Strategy & Advisory",
        "name": "Platform Migration",
        "slug": "platform-migration",
        "shortDescription": "Seamless migration of applications, data, and systems to modern platforms with minimal disruption.",
        "headline": "Modernize infrastructure and scale confidently with secure platform transitions.",
        "capabilities": [
            {
                "id": "1",
                "name": "Assess legacy systems, dependencies, and architecture to define the optimal migration strategy."
            },
            {
                "id": "2",
                "name": "Execute secure data migration with validation, integrity checks, and minimal downtime."
            },
            {
                "id": "3",
                "name": "Re-architect applications for cloud, SaaS, or hybrid environments."
            },
            {
                "id": "4",
                "name": "Ensure compliance, security, and performance optimization throughout migration."
            },
            {
                "id": "5",
                "name": "Provide post-migration testing, monitoring, and performance tuning."
            }
        ],
        "storyId": 47,
        "storyheadline": "seamless-platform-modernization-with-zero-business-disruption",
        "impact": {
            "description": "Antrazal enables organizations to transition from legacy systems to modern platforms efficiently and securely, ensuring business continuity, improved scalability, and long-term technology readiness.",
            "items": [
                {
                    "id": "1",
                    "measure": "80+",
                    "title": "Platforms successfully migrated"
                },
                {
                    "id": "2",
                    "measure": "99.9%",
                    "name": "Data integrity maintained during migrations"
                }
            ]
        }
    },
    {
        "id": "52",
        "category": "Strategy & Advisory",
        "name": "Technology Revamp",
        "slug": "technology-revamp",
        "shortDescription": "Modernize legacy systems, architectures, and tech stacks to improve performance, scalability, and innovation readiness.",
        "headline": "Transform outdated technology into a future-ready digital foundation.",
        "capabilities": [
            {
                "id": "1",
                "name": "Evaluate existing infrastructure, applications, and architecture to identify modernization opportunities."
            },
            {
                "id": "2",
                "name": "Redesign technology stacks using modern frameworks, cloud platforms, and scalable architectures."
            },
            {
                "id": "3",
                "name": "Optimize system performance, reliability, and security through refactoring and upgrades."
            },
            {
                "id": "4",
                "name": "Implement automation, integrations, and DevOps practices for faster delivery cycles."
            },
            {
                "id": "5",
                "name": "Establish governance, documentation, and future scalability strategies."
            }
        ],
        "storyId": 48,
        "storyheadline": "revitalizing-technology-for-scalable-digital-growth",
        "impact": {
            "description": "Antrazal helps organizations revitalize their technology ecosystem by modernizing legacy systems, improving efficiency, and enabling innovation with scalable, secure, and future-ready digital solutions.",
            "items": [
                {
                    "id": "1",
                    "measure": "60+",
                    "title": "Systems modernized"
                },
                {
                    "id": "2",
                    "measure": "3x",
                    "name": "Average performance improvement"
                }
            ]
        }
    },
    {
        "id": "53",
        "category": "Strategy & Advisory",
        "name": "Data Governance and Security",
        "slug": "data-governance-security",
        "shortDescription": "Establish structured data governance frameworks and security strategies to protect, manage, and maximize the value of enterprise data.",
        "headline": "Secure, govern, and control your data with confidence.",
        "capabilities": [
            {
                "id": "1",
                "name": "Design enterprise data governance frameworks including ownership models, policies, and stewardship processes."
            },
            {
                "id": "2",
                "name": "Implement data classification, access controls, and encryption standards to ensure compliance and protection."
            },
            {
                "id": "3",
                "name": "Establish data quality monitoring, validation rules, and lifecycle management processes."
            },
            {
                "id": "4",
                "name": "Deploy risk assessment, audit readiness, and regulatory compliance strategies across systems."
            },
            {
                "id": "5",
                "name": "Enable secure data sharing and integration while maintaining visibility, traceability, and governance controls."
            }
        ],
        "storyId": 49,
        "storyheadline": "building-trust-through-secure-and-governed-data-ecosystems",
        "impact": {
            "description": "Antrazal empowers organizations to safeguard critical data assets while improving transparency, compliance, and decision-making through robust governance frameworks and advanced security strategies.",
            "items": [
                {
                    "id": "1",
                    "measure": "100%",
                    "title": "Policy-driven data access control"
                },
                {
                    "id": "2",
                    "measure": "70%",
                    "name": "Reduction in data risk exposure"
                }
            ]
        }
    },
    {
        "id": "54",
        "category": "Design",
        "name": "User Experience",
        "slug": "user-experience",
        "shortDescription": "Design intuitive, user-centered digital experiences that enhance engagement, usability, and customer satisfaction across platforms.",
        "headline": "Create seamless experiences users love and trust.",
        "capabilities": [
            {
                "id": "1",
                "name": "Conduct user research, persona creation, and journey mapping to understand audience needs and behaviors."
            },
            {
                "id": "2",
                "name": "Design wireframes, prototypes, and interaction flows that optimize usability and accessibility."
            },
            {
                "id": "3",
                "name": "Implement responsive and mobile-first interface designs tailored for multi-device experiences."
            },
            {
                "id": "4",
                "name": "Perform usability testing, feedback analysis, and iterative improvements for continuous enhancement."
            },
            {
                "id": "5",
                "name": "Align UX strategy with business goals to increase engagement, retention, and conversion rates."
            }
        ],
        "storyId": 50,
        "storyheadline": "designing-intuitive-digital-experiences-that-drive-engagement",
        "impact": {
            "description": "Antrazal crafts user-first digital experiences that blend design thinking, usability principles, and strategic insight to deliver intuitive interfaces that improve satisfaction and business performance.",
            "items": [
                {
                    "id": "1",
                    "measure": "85%",
                    "title": "Increase in user engagement"
                },
                {
                    "id": "2",
                    "measure": "60%",
                    "name": "Improvement in task completion rates"
                }
            ]
        }
    },
    {
        "id": "55",
        "category": "Design",
        "name": "Design Thinking",
        "slug": "design-thinking",
        "shortDescription": "Human-centered innovation approach that solves complex problems through creativity, empathy, and rapid experimentation.",
        "headline": "Turn ideas into impactful solutions through user-driven innovation.",
        "capabilities": [
            {
                "id": "1",
                "name": "Conduct empathy research and stakeholder workshops to deeply understand user needs, pain points, and motivations."
            },
            {
                "id": "2",
                "name": "Define problem statements and opportunity areas using structured ideation and insight synthesis frameworks."
            },
            {
                "id": "3",
                "name": "Facilitate collaborative brainstorming sessions that generate innovative, practical, and scalable solution concepts."
            },
            {
                "id": "4",
                "name": "Build rapid prototypes and validate ideas through iterative testing and real user feedback loops."
            },
            {
                "id": "5",
                "name": "Align business goals, technology feasibility, and user desirability to ensure solutions are viable, valuable, and implementable."
            }
        ],
        "storyId": 51,
        "storyheadline": "human-centered-innovation-for-smarter-solutions",
        "impact": {
            "description": "Antrazal applies structured design thinking methodologies to help organizations innovate confidently, reduce risk, and deliver solutions that truly resonate with users and stakeholders.",
            "items": [
                {
                    "id": "1",
                    "measure": "5x",
                    "title": "Faster solution validation cycles"
                },
                {
                    "id": "2",
                    "measure": "70%",
                    "name": "Improvement in solution adoption rates"
                }
            ]
        }
    },
    {
        "id": "56",
        "category": "Design",
        "name": "Prototyping & Wireframing",
        "slug": "prototyping-&-wireframing",
        "shortDescription": "Visualize product concepts and user flows before development through structured design prototypes.",
        "headline": "Validate ideas faster with interactive design blueprints.",
        "capabilities": [
            {
                "id": "1",
                "name": "Create low-fidelity wireframes to map layouts, navigation paths, and information architecture."
            },
            {
                "id": "2",
                "name": "Develop interactive prototypes that simulate real user experiences and system behavior."
            },
            {
                "id": "3",
                "name": "Test usability early with stakeholder and user feedback to refine designs before development."
            },
            {
                "id": "4",
                "name": "Design scalable UI structures aligned with brand standards and accessibility best practices."
            },
            {
                "id": "5",
                "name": "Collaborate with product and engineering teams to translate concepts into build-ready specifications."
            }
        ],
        "storyId": 52,
        "storyheadline": "transforming-ideas-into-validated-design-experiences",
        "impact": {
            "description": "Antrazal accelerates product innovation by transforming concepts into validated visual models, reducing development risk and ensuring solutions meet real user expectations before launch.",
            "items": [
                {
                    "id": "1",
                    "measure": "60%",
                    "title": "Reduction in design revision cycles"
                },
                {
                    "id": "2",
                    "measure": "3X",
                    "name": "Faster stakeholder approval timelines"
                }
            ]
        }
    },
    {
        "id": "57",
        "category": "DevOps",
        "name": "AWS",
        "slug": "aws",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo18.png",
        "shortDescription": "Scalable cloud infrastructure and DevOps solutions powered by AWS for secure, high-performance applications.",
        "headline": "Build, deploy, and scale faster with cloud-native DevOps on AWS.",
        "capabilities": [
            {
                "id": "1",
                "name": "Design and implement secure, scalable AWS cloud architectures tailored to application performance, compliance, and business growth requirements."
            },
            {
                "id": "2",
                "name": "Automate infrastructure provisioning using Infrastructure as Code to ensure consistency, repeatability, and rapid environment setup."
            },
            {
                "id": "3",
                "name": "Establish CI/CD pipelines that streamline build, test, and deployment processes for faster and more reliable releases."
            },
            {
                "id": "4",
                "name": "Monitor systems proactively with logging, alerts, and performance analytics to maintain uptime and operational stability."
            },
            {
                "id": "5",
                "name": "Optimize cloud costs and resource utilization through performance tuning, scaling strategies, and governance best practices."
            }
        ],
        "storyId": 53,
        "storyheadline": "accelerating-cloud-innovation-with-aws-devops",
        "impact": {
            "description": "Antrazal enables organizations to modernize infrastructure and accelerate delivery through AWS-powered DevOps solutions that enhance scalability, reliability, and deployment speed while maintaining enterprise-grade security.",
            "items": [
                {
                    "id": "1",
                    "measure": "70%",
                    "title": "Faster deployment cycles achieved"
                },
                {
                    "id": "2",
                    "measure": "99.9%",
                    "name": "Infrastructure uptime maintained"
                }
            ]
        }
    },
    {
        "id": "58",
        "category": "DevOps",
        "name": "Copado",
        "slug": "copado",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo17.png",
        "shortDescription": "Salesforce DevOps platform for automated releases, testing, and compliant deployments.",
        "headline": "Accelerate Salesforce delivery with intelligent DevOps automation.",
        "capabilities": [
            {
                "id": "1",
                "name": "Automate end-to-end Salesforce release pipelines with version control, continuous integration, and continuous delivery workflows."
            },
            {
                "id": "2",
                "name": "Enable collaborative development with user story tracking, environment management, and deployment visibility."
            },
            {
                "id": "3",
                "name": "Implement automated testing frameworks that validate code quality, performance, and compliance before release."
            },
            {
                "id": "4",
                "name": "Ensure secure and compliant deployments using governance controls, audit trails, and approval workflows."
            },
            {
                "id": "5",
                "name": "Monitor release performance metrics and optimize delivery cycles through real-time DevOps analytics."
            }
        ],
        "storyId": 53,
        "storyheadline": "streamlining-salesforce-delivery-with-devops-automation",
        "impact": {
            "description": "Antrazal empowers organizations to modernize Salesforce development with Copado-driven DevOps automation, reducing release risks, accelerating deployment speed, and improving overall software quality across environments.",
            "items": [
                {
                    "id": "1",
                    "measure": "80%",
                    "title": "Faster deployment cycles"
                },
                {
                    "id": "2",
                    "measure": "65%",
                    "name": "Reduction in release failures"
                }
            ]
        }
    },
    {
        "id": "59",
        "category": "DevOps",
        "name": "Gearset",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo1`7.png",
        "slug": "gearset",
        "shortDescription": "Salesforce DevOps and release management platform for faster, safer deployments.",
        "headline": "Automate deployments and manage releases with confidence.",
        "capabilities": [
            {
                "id": "1",
                "name": "Automate Salesforce deployments with CI/CD pipelines that reduce manual effort and release risk."
            },
            {
                "id": "2",
                "name": "Compare orgs and track metadata differences to maintain consistency across environments."
            },
            {
                "id": "3",
                "name": "Monitor deployments in real time with detailed logs, alerts, and rollback capabilities."
            },
            {
                "id": "4",
                "name": "Enforce quality standards using automated testing, validation checks, and compliance rules."
            },
            {
                "id": "5",
                "name": "Manage version control integrations to streamline collaboration between development and operations teams."
            }
        ],
        "storyId": 53,
        "storyheadline": "streamlined-salesforce-releases-with-devops-automation",
        "impact": {
            "description": "Antrazal empowers organizations to modernize their Salesforce DevOps processes using Gearset, enabling faster releases, improved deployment reliability, and greater development team productivity through automation and intelligent release management.",
            "items": [
                {
                    "id": "1",
                    "measure": "80%",
                    "title": "Faster deployment cycles"
                },
                {
                    "id": "2",
                    "measure": "90%",
                    "name": "Reduction in release errors"
                }
            ]
        }
    },
    {
        "id": "60",
        "category": "AI",
        "name": "Chat Agents",
         "slug": "chat-agents",
        "shortDescription": "Intelligent conversational agents that automate support, engagement, and business workflows.",
        "headline": "Deliver instant, human-like interactions with AI-powered chat automation.",
        "capabilities": [
            {
                "id": "1",
                "name": "Build conversational AI agents capable of handling customer queries, internal requests, and guided workflows autonomously."
            },
            {
                "id": "2",
                "name": "Train chat agents using business knowledge bases, documents, and real-time data sources for accurate responses."
            },
            {
                "id": "3",
                "name": "Integrate chatbots across websites, apps, CRMs, and messaging platforms for unified engagement experiences."
            },
            {
                "id": "4",
                "name": "Enable contextual understanding, sentiment detection, and intent recognition for smarter conversations."
            },
            {
                "id": "5",
                "name": "Track performance analytics and conversation insights to continuously optimize response accuracy and efficiency."
            }
        ],
        "storyId": 53,
        "storyheadline": "ai-conversational-agents-transforming-digital-engagement",
        "impact": {
            "description": "Antrazal empowers organizations with intelligent chat agents that streamline communication, reduce operational workload, and enhance customer satisfaction through real-time automated interactions.",
            "items": [
                {
                    "id": "1",
                    "measure": "70%",
                    "title": "Reduction in support response time"
                },
                {
                    "id": "2",
                    "measure": "24/7",
                    "name": "Automated customer interaction availability"
                }
            ]
        }
    },
    {
        "id": "61",
        "category": "AI",
        "name": "Voice Agents",
        "slug": "voice-agents",
        "shortDescription": "AI-powered conversational voice agents that automate calls, support interactions, and real-time responses.",
        "headline": "Enable intelligent voice conversations that work 24/7.",
        "capabilities": [
            {
                "id": "1",
                "name": "Deploy AI voice agents capable of handling inbound and outbound calls with natural language understanding."
            },
            {
                "id": "2",
                "name": "Automate customer support, appointment booking, reminders, and notifications through voice interactions."
            },
            {
                "id": "3",
                "name": "Integrate voice systems with CRM, ticketing, and backend platforms for real-time data access."
            },
            {
                "id": "4",
                "name": "Train conversational models using business-specific datasets for contextual and accurate responses."
            },
            {
                "id": "5",
                "name": "Monitor conversations with analytics dashboards to optimize performance, quality, and engagement."
            }
        ],
        "storyId": 53,
        "storyheadline": "ai-voice-automation-for-intelligent-customer-engagement",
        "impact": {
            "description": "Antrazal empowers organizations with AI-driven voice automation that enhances customer interactions, reduces operational workload, and delivers scalable, real-time communication experiences.",
            "items": [
                {
                    "id": "1",
                    "measure": "80%",
                    "title": "Reduction in manual call handling"
                },
                {
                    "id": "2",
                    "measure": "24/7",
                    "name": "Automated voice support availability"
                }
            ]
        }
    },
    {
        "id": "62",
        "category": "AI",
        "name": "Sales Agents (Sentiment)",
        "slug": "sales-agents-(sentiment)",
        "shortDescription": "AI-powered sales agents that analyze customer sentiment to improve engagement, conversions, and relationship outcomes.",
        "headline": "Understand buyer emotions and respond with precision using AI-driven sentiment intelligence.",
        "capabilities": [
            {
                "id": "1",
                "name": "Analyze customer tone, intent, and sentiment across calls, chats, and emails to understand real-time buyer mindset."
            },
            {
                "id": "2",
                "name": "Provide sales teams with live sentiment insights and recommended responses to improve communication effectiveness."
            },
            {
                "id": "3",
                "name": "Detect buying signals, hesitation patterns, and objections using machine learning models trained on conversation data."
            },
            {
                "id": "4",
                "name": "Automate follow-up prioritization based on emotional engagement scores and likelihood-to-convert predictions."
            },
            {
                "id": "5",
                "name": "Generate performance analytics that help leaders optimize sales scripts, coaching strategies, and deal approaches."
            }
        ],
        "storyId": 53,
        "storyheadline": "ai-driven-sales-intelligence-powered-by-sentiment-analysis",
        "impact": {
            "description": "Antrazal enables organizations to close deals faster and build stronger customer relationships by deploying AI sentiment intelligence that reveals buyer intent, guides sales conversations, and enhances decision-making with actionable emotional insights.",
            "items": [
                {
                    "id": "1",
                    "measure": "35%",
                    "title": "Increase in sales conversion rates"
                },
                {
                    "id": "2",
                    "measure": "50%+",
                    "name": "Improvement in engagement quality scores"
                }
            ]
        }
    },
    {
        "id": "63",
        "category": "AI",
        "name": "AI Service Agents",
        "slug": "ai-service-agents",
        "shortDescription": "AI-powered service agents that automate customer support, issue resolution, and operational assistance.",
        "headline": "Deliver intelligent support with autonomous service agents.",
        "capabilities": [
            {
                "id": "1",
                "name": "Deploy AI service agents that handle customer queries, requests, and support tasks automatically across channels."
            },
            {
                "id": "2",
                "name": "Enable natural language understanding to interpret user intent and provide accurate contextual responses."
            },
            {
                "id": "3",
                "name": "Integrate agents with CRM, ticketing, and backend systems for real-time data access and action execution."
            },
            {
                "id": "4",
                "name": "Continuously learn from interactions to improve response accuracy, efficiency, and customer satisfaction."
            },
            {
                "id": "5",
                "name": "Provide analytics dashboards to monitor performance, resolution rates, and automation effectiveness."
            }
        ],
        "storyId": 53,
        "storyheadline": "ai-driven-support-automation-for-modern-service-experiences",
        "impact": {
            "description": "Antrazal helps organizations scale support operations with AI-powered service agents that automate resolutions, reduce response times, and enhance customer satisfaction through intelligent assistance.",
            "items": [
                {
                    "id": "1",
                    "measure": "70%",
                    "title": "Faster response times"
                },
                {
                    "id": "2",
                    "measure": "65%",
                    "name": "Reduction in manual support workload"
                }
            ]
        }
    },
    {
        "id": "64",
        "category": "Snowflake",
        "name": "Snowflake Implementation & Migration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo16.png",
        "slug": "snowflake-implementation-&-migration",
        "shortDescription": "Implement and migrate data platforms to Snowflake for scalable, secure, and high-performance analytics.",
        "headline": "Modernize your data ecosystem with seamless cloud migration.",
        "capabilities": [
            {
                "id": "1",
                "name": "Design and deploy Snowflake architectures optimized for performance, scalability, and cost efficiency."
            },
            {
                "id": "2",
                "name": "Migrate legacy databases, warehouses, and on-prem systems to Snowflake with minimal downtime and data integrity assurance."
            },
            {
                "id": "3",
                "name": "Build secure data pipelines and automated ingestion frameworks for real-time and batch processing."
            },
            {
                "id": "4",
                "name": "Implement governance, role-based access, and compliance controls to ensure enterprise-grade data security."
            },
            {
                "id": "5",
                "name": "Enable advanced analytics, BI integrations, and data sharing capabilities for cross-department insights."
            }
        ],
        "storyId": 53,
        "storyheadline": "scalable-cloud-data-foundations-for-modern-enterprises",
        "impact": {
            "description": "Antrazal empowers organizations to unlock the full potential of their data by implementing Snowflake solutions that enhance scalability, streamline analytics, and deliver faster, insight-driven decision making.",
            "items": [
                {
                    "id": "1",
                    "measure": "10TB+",
                    "title": "Data successfully migrated"
                },
                {
                    "id": "2",
                    "measure": "5X",
                    "name": "Improvement in query performance"
                }
            ]
        }
    },
    {
        "id": "65",
        "category": "Snowflake",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo16.png",
        "name": "Data Engineering & Pipelines",
        "slug": "snowflake-data-engineering-&-pipelines",
        "shortDescription": "Build scalable Snowflake data pipelines that transform raw data into analytics-ready insights.",
        "headline": "Power real-time decisions with automated data pipelines.",
        "capabilities": [
            {
                "id": "1",
                "name": "Design and implement robust ETL and ELT pipelines that ingest, transform, and load structured and unstructured data efficiently."
            },
            {
                "id": "2",
                "name": "Develop scalable data architectures optimized for Snowflake performance, cost efficiency, and high-volume workloads."
            },
            {
                "id": "3",
                "name": "Automate data workflows using orchestration frameworks to ensure reliable scheduling, monitoring, and error handling."
            },
            {
                "id": "4",
                "name": "Enable real-time and batch data streaming integrations from multiple sources including APIs, applications, and databases."
            },
            {
                "id": "5",
                "name": "Implement data quality validation, governance policies, and transformation logic to deliver clean and analytics-ready datasets."
            }
        ],
        "storyId": 53,
        "storyheadline": "scalable-data-foundations-for-modern-analytics",
        "impact": {
            "description": "Antrazal empowers organizations to unlock the full value of their data by building high-performance Snowflake pipelines that ensure accuracy, scalability, and real-time accessibility for advanced analytics and strategic decision-making.",
            "items": [
                {
                    "id": "1",
                    "measure": "10TB+",
                    "title": "Data processed daily"
                },
                {
                    "id": "2",
                    "measure": "99.9%",
                    "name": "Pipeline reliability achieved"
                }
            ]
        }
    },
    {
        "id": "66",
        "category": "Snowflake",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo16.png",
        "name": "Data Warehousing & BI Enablement",
        "slug": "data-warehousing-&-bi-enablement",
        "shortDescription": "Modern cloud data warehousing and business intelligence solutions for unified analytics and reporting.",
        "headline": "Transform raw data into actionable intelligence with scalable cloud analytics.",
        "capabilities": [
            {
                "id": "1",
                "name": "Design and implement scalable cloud data warehouses optimized for performance, cost efficiency, and real-time analytics."
            },
            {
                "id": "2",
                "name": "Integrate structured and unstructured data from multiple sources into a centralized, analytics-ready repository."
            },
            {
                "id": "3",
                "name": "Enable advanced BI dashboards and visualization layers that provide real-time insights for faster decision-making."
            },
            {
                "id": "4",
                "name": "Optimize data models, query performance, and storage strategies to ensure high-speed reporting and analytics."
            },
            {
                "id": "5",
                "name": "Implement secure data governance, role-based access, and compliance frameworks for enterprise-grade data protection."
            }
        ],
        "storyId": 53,
        "storyheadline": "building-a-scalable-foundation-for-enterprise-analytics",
        "impact": {
            "description": "Antrazal empowers organizations with modern data warehousing and BI capabilities that unify data, accelerate analytics, and enable leadership teams to make confident, data-driven decisions at scale.",
            "items": [
                {
                    "id": "1",
                    "measure": "10TB+",
                    "title": "Enterprise data consolidated"
                },
                {
                    "id": "2",
                    "measure": "5X",
                    "name": "Faster analytics query performance"
                }
            ]
        }
    },
    {
        "id": "67",
        "category": "MS Dynamics",
        "name": "Dynamics 365 CRM Implementation",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo13.png",
        "slug": "dynamics-365-crm-implementation",
        "shortDescription": "Implement Microsoft Dynamics 365 CRM to unify sales, marketing, and customer service operations on a scalable platform.",
        "headline": "Accelerate customer engagement with a fully integrated CRM ecosystem.",
        "capabilities": [
            {
                "id": "1",
                "name": "Design and deploy tailored Dynamics 365 CRM architectures aligned with business processes and growth strategies."
            },
            {
                "id": "2",
                "name": "Configure custom entities, workflows, dashboards, and automation rules to streamline operations and improve productivity."
            },
            {
                "id": "3",
                "name": "Integrate ERP systems, marketing platforms, and third-party applications for seamless cross-system data flow."
            },
            {
                "id": "4",
                "name": "Migrate legacy data securely with validation, cleansing, and transformation for accurate CRM adoption."
            },
            {
                "id": "5",
                "name": "Enable user adoption through training, documentation, and performance optimization for long-term success."
            }
        ],
        "storyId": 53,
        "storyheadline": "connected-crm-ecosystem-for-smarter-customer-management",
        "impact": {
            "description": "Antrazal empowers organizations to maximize CRM value through strategic Dynamics 365 implementation, delivering unified customer insights, streamlined operations, and scalable digital infrastructure for sustainable growth.",
            "items": [
                {
                    "id": "1",
                    "measure": "120+",
                    "title": "CRM implementations delivered"
                },
                {
                    "id": "2",
                    "measure": "65%",
                    "name": "Increase in operational efficiency"
                }
            ]
        }
    },
    {
        "id": "68",
        "category": "MS Dynamics",
        "name": "Dynamics 365 ERP Solutions",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo13.png",
        "slug": "dynamics-365-erp-solutions",
        "shortDescription": "Integrated ERP solutions to streamline finance, operations, supply chain, and business performance.",
        "headline": "Unify operations with intelligent, scalable ERP systems.",
        "capabilities": [
            {
                "id": "1",
                "name": "Implement end-to-end ERP systems that connect finance, procurement, inventory, and operations in one unified platform."
            },
            {
                "id": "2",
                "name": "Automate financial processes including accounting, reporting, budgeting, and compliance management."
            },
            {
                "id": "3",
                "name": "Optimize supply chain visibility with real-time inventory tracking, demand forecasting, and logistics insights."
            },
            {
                "id": "4",
                "name": "Enable data-driven decisions through built-in analytics, dashboards, and predictive intelligence."
            },
            {
                "id": "5",
                "name": "Customize ERP workflows and integrations to align with business processes and industry requirements."
            }
        ],
        "storyId": 53,
        "storyheadline": "connected-enterprise-operations-with-intelligent-erp",
        "impact": {
            "description": "Antrazal empowers organizations to modernize operations with Dynamics ERP solutions that improve financial visibility, streamline workflows, and create scalable foundations for long-term growth.",
            "items": [
                {
                    "id": "1",
                    "measure": "40%",
                    "title": "Increase in operational efficiency"
                },
                {
                    "id": "2",
                    "measure": "2X",
                    "name": "Faster financial reporting cycles"
                }
            ]
        }
    },
    {
        "id": "69",
        "category": "MS Dynamics",
        "name": "Customization & Integration",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo13.png",
        "slug": "customization-&-integration",
        "shortDescription": "Tailored Dynamics solutions with seamless integrations across your business ecosystem.",
        "headline": "Adapt your platform to your processes, not the other way around.",
        "capabilities": [
            {
                "id": "1",
                "name": "Customize modules, workflows, and entities to match unique business processes and operational needs."
            },
            {
                "id": "2",
                "name": "Integrate Dynamics with CRMs, ERPs, payment systems, and third-party applications for unified data flow."
            },
            {
                "id": "3",
                "name": "Develop custom plugins, APIs, and automation scripts to extend platform functionality."
            },
            {
                "id": "4",
                "name": "Implement real-time data synchronization to eliminate silos and ensure system consistency."
            },
            {
                "id": "5",
                "name": "Optimize performance, security, and scalability while maintaining compliance and system stability."
            }
        ],
        "storyId": 54,
        "storyheadline": "building-connected-systems-with-tailored-dynamics-solutions",
        "impact": {
            "description": "Antrazal helps organizations unlock the full potential of Dynamics platforms through strategic customization and intelligent integrations that streamline operations, enhance productivity, and create a unified digital ecosystem.",
            "items": [
                {
                    "id": "1",
                    "measure": "150+",
                    "title": "Custom integrations delivered"
                },
                {
                    "id": "2",
                    "measure": "99.9%",
                    "name": "System data synchronization accuracy"
                }
            ]
        }
    },
    {
        "id": "70",
        "category": "MS Dynamics",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo13.png",
        "name": "Support & Optimization Services",
        "slug": "support-&-optimization-services",
        "shortDescription": "Continuous support and performance optimization to keep your Dynamics platform efficient, secure, and scalable.",
        "headline": "Maximize platform performance with proactive support and optimization.",
        "capabilities": [
            {
                "id": "1",
                "name": "Provide ongoing technical support, monitoring, and troubleshooting to ensure uninterrupted system performance."
            },
            {
                "id": "2",
                "name": "Optimize workflows, automations, and configurations to improve speed, usability, and productivity."
            },
            {
                "id": "3",
                "name": "Conduct system health audits and performance tuning to maintain peak operational efficiency."
            },
            {
                "id": "4",
                "name": "Implement updates, patches, and enhancements while ensuring stability and compliance."
            },
            {
                "id": "5",
                "name": "Deliver strategic recommendations and continuous improvements aligned with evolving business needs."
            }
        ],
        "storyId": 55,
        "storyheadline": "ensuring-continuous-performance-and-platform-excellence",
        "impact": {
            "description": "Antrazal ensures long-term platform success by providing proactive support and optimization services that enhance system reliability, boost user productivity, and keep your Dynamics environment aligned with business growth.",
            "items": [
                {
                    "id": "1",
                    "measure": "99.8%",
                    "title": "Average platform uptime maintained"
                },
                {
                    "id": "2",
                    "measure": "45%",
                    "name": "Reduction in performance-related issues"
                }
            ]
        }
    },
    {
        "id": "70",
        "category": "MS Dynamics",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo13.png",
        "name": "Power Platform Enablement",
        "slug": "power-platform-enablement",
        "shortDescription": "Enable rapid innovation with low-code tools for apps, automation, analytics, and intelligent business solutions.",
        "headline": "Build, automate, and analyze faster with Microsoft Power Platform.",
        "capabilities": [
            {
                "id": "1",
                "name": "Develop custom business applications quickly using low-code tools tailored to operational requirements."
            },
            {
                "id": "2",
                "name": "Automate workflows and repetitive tasks with intelligent process automation across systems and teams."
            },
            {
                "id": "3",
                "name": "Create real-time dashboards and reports that provide actionable insights for faster decision-making."
            },
            {
                "id": "4",
                "name": "Integrate data sources, APIs, and enterprise platforms to enable seamless information flow."
            },
            {
                "id": "5",
                "name": "Empower teams with self-service tools while maintaining governance, security, and compliance standards."
            }
        ],
        "storyId": 56,
        "storyheadline": "accelerating-innovation-through-low-code-platform-enablement",
        "impact": {
            "description": "Antrazal empowers organizations to innovate rapidly with Power Platform solutions that streamline processes, reduce development time, and enable teams to build scalable digital tools without heavy coding.",
            "items": [
                {
                    "id": "1",
                    "measure": "70%",
                    "title": "Faster application development cycles"
                },
                {
                    "id": "2",
                    "measure": "3X",
                    "name": "Increase in workflow automation efficiency"
                }
            ]
        }
    },
    {
        "id": "57",
        "category": "Other",
        "name": "Zoho",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo15.png",
        "slug": "zoho",
        "shortDescription": "Unified business platform to manage sales, marketing, finance, support, and operations from one ecosystem.",
        "headline": "Run your entire business seamlessly with connected Zoho applications.",
        "capabilities": [
            {
                "id": "1",
                "name": "Implement and configure Zoho applications tailored to sales, marketing, finance, HR, and customer operations."
            },
            {
                "id": "2",
                "name": "Automate business workflows, approvals, notifications, and data synchronization across departments."
            },
            {
                "id": "3",
                "name": "Customize modules, fields, dashboards, and reports to align with your organization’s processes."
            },
            {
                "id": "4",
                "name": "Integrate Zoho with third-party systems, payment platforms, CRMs, and enterprise tools for unified data flow."
            },
            {
                "id": "5",
                "name": "Enable real-time analytics and performance insights to support strategic decisions and growth."
            }
        ],
        "storyId": 57,
        "storyheadline": "building-connected-business-operations-with-zoho-ecosystem",
        "impact": {
            "description": "Antrazal helps organizations unlock the full potential of Zoho’s ecosystem by creating connected, automated, and scalable digital environments that improve efficiency, visibility, and business performance.",
            "items": [
                {
                    "id": "1",
                    "measure": "120+",
                    "title": "Zoho implementations delivered"
                },
                {
                    "id": "2",
                    "measure": "65%",
                    "name": "Average workflow automation improvement"
                }
            ]
        }
    },
    {
        "id": "71",
        "category": "other",
        "name": "ServiceNow",
        "logo": 'https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo14.png',
        "slug": "servicenow",
        "shortDescription": "Enterprise workflow automation platform for IT, HR, operations, and customer service management.",
        "headline": "Streamline enterprise operations with intelligent digital workflows.",
        "capabilities": [
            {
                "id": "1",
                "name": "Implement unified service management solutions that connect IT, HR, customer support, and operations on a single platform."
            },
            {
                "id": "2",
                "name": "Automate enterprise workflows and approvals to eliminate manual processes and increase operational efficiency."
            },
            {
                "id": "3",
                "name": "Design custom applications and modules tailored to organizational processes and compliance requirements."
            },
            {
                "id": "4",
                "name": "Enable real-time visibility into performance, incidents, and service metrics through intelligent dashboards."
            },
            {
                "id": "5",
                "name": "Integrate enterprise systems and data sources to create seamless cross-departmental service experiences."
            }
        ],
        "storyId": 57,
        "storyheadline": "transforming-enterprise-operations-with-unified-workflows",
        "impact": {
            "description": "Antrazal helps organizations modernize operations with ServiceNow solutions that automate workflows, enhance service delivery, and provide real-time operational intelligence for scalable digital transformation.",
            "items": [
                {
                    "id": "1",
                    "measure": "65%",
                    "title": "Reduction in manual service processes"
                },
                {
                    "id": "2",
                    "measure": "2.5X",
                    "name": "Improvement in workflow efficiency"
                }
            ]
        }
    },
    {
        "id": "72",
        "category": "Other",
        "name": "MS Dynamics",
        "logo": "https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo13.png",
        "slug": "ms-dynamics",
        "shortDescription": "Comprehensive Microsoft Dynamics solutions for CRM, ERP, automation, and enterprise process optimization.",
        "headline": "Transform business operations with a unified intelligent platform.",
        "capabilities": [
            {
                "id": "1",
                "name": "Implement end-to-end Dynamics solutions that unify sales, service, finance, and operations within a single ecosystem."
            },
            {
                "id": "2",
                "name": "Automate business workflows and processes to increase efficiency, reduce manual effort, and improve accuracy."
            },
            {
                "id": "3",
                "name": "Integrate Dynamics with enterprise applications, data platforms, and third-party systems for seamless connectivity."
            },
            {
                "id": "4",
                "name": "Deliver real-time analytics and reporting dashboards that support data-driven decision making."
            },
            {
                "id": "5",
                "name": "Customize modules, interfaces, and automation logic tailored to organizational workflows and industry needs."
            }
        ],
        "storyId": 57,
        "storyheadline": "modernizing-business-systems-with-unified-dynamics-platform",
        "impact": {
            "description": "Antrazal enables organizations to streamline operations, enhance visibility, and accelerate growth through strategically implemented Dynamics solutions that align technology with business performance goals.",
            "items": [
                {
                    "id": "1",
                    "measure": "55%",
                    "title": "Improvement in process efficiency"
                },
                {
                    "id": "2",
                    "measure": "2.5X",
                    "name": "Increase in operational visibility"
                }
            ]
        }
    },
    {
        "id": "73",
        "category": "Other",
        "name": "Azure",
        "logo": 'https://d2lyw5vkb9es5b.cloudfront.net/ServiceLogo12.png',
        "slug": "azure",
        "shortDescription": "Scalable cloud infrastructure and enterprise solutions powered by Microsoft Azure.",
        "headline": "Build, deploy, and scale securely with intelligent cloud innovation.",
        "capabilities": [
            {
                "id": "1",
                "name": "Design and deploy secure cloud infrastructure including virtual machines, networking, storage, and Kubernetes environments."
            },
            {
                "id": "2",
                "name": "Migrate on-premise applications and workloads to Azure with minimal downtime and optimized performance."
            },
            {
                "id": "3",
                "name": "Implement cloud-native architectures using microservices, containers, and serverless computing."
            },
            {
                "id": "4",
                "name": "Leverage Azure AI, analytics, and data services for advanced business intelligence and predictive insights."
            },
            {
                "id": "5",
                "name": "Ensure enterprise-grade security, compliance, backup, disaster recovery, and cost optimization strategies."
            }
        ],
        "storyId": 57,
        "storyheadline": "scalable-secure-and-intelligent-cloud-transformation",
        "impact": {
            "description": "Antrazal enables organizations to harness the full potential of Azure by delivering secure, scalable, and high-performance cloud environments that accelerate innovation, reduce infrastructure costs, and support long-term digital growth.",
            "items": [
                {
                    "id": "1",
                    "measure": "99.9%",
                    "title": "Cloud uptime reliability delivered"
                },
                {
                    "id": "2",
                    "measure": "40%",
                    "name": "Reduction in infrastructure costs"
                }
            ]
        }
    }
];